<template>
    <div class="mx-3 users-tab-wrapper">
        <v-row>
            <v-col>
                <v-text-field v-model="filterText" :label="$gettext('Search')" append-icon="mdi-magnify" clearable>
                </v-text-field>
            </v-col>
            <!--            <v-col class="text-right d-flex align-center justify-end" cols="2" md="1">
                <v-btn-toggle v-model="userGroupTabFilter" multiple>
                    <v-btn :fab="$vuetify.breakpoint.smAndDown" :small="$vuetify.breakpoint.smAndDown"
                           :title="$gettext('Add user group')"
                           icon
                           plain @click.native.stop="openAddCategoryDialog()">
                        <v-icon :small="$vuetify.breakpoint.smAndDown" v-text="icons.mdiAccountMultiplePlus"></v-icon>
                    </v-btn>
                </v-btn-toggle>
            </v-col>-->
        </v-row>

        <!--        <v-row>
                    &lt;!&ndash; If we don't have the second condition, when the search term is typed with something that doesn't exist, the search itself will hide. &ndash;&gt;
                    <v-col v-if="haveUsers || (userAutoCompleteFilterValue2 && userAutoCompleteFilterValue2.length > 0)"
                           cols="10"
                           md="11">

                        <v-text-field
                            ref="userSearch" v-model="userAutoCompleteFilterValue2"
                            :items="prepareAnArrayForAutocompleteTopLevel(users)"
                            :label="$gettext('Search users')" append-icon="mdi-magnify"
                            clearable></v-text-field>
                    </v-col>
                    <v-col v-if="haveUsers" class="text-right d-flex align-center justify-end" cols="2" md="1">
                        <v-btn-toggle v-model="userGroupTabFilter" multiple>
                            <v-btn :fab="$vuetify.breakpoint.smAndDown" :small="$vuetify.breakpoint.smAndDown"
                                   :title="$gettext('Add user group')"
                                   icon
                                   plain @click.native.stop="openAddCategoryDialog()">
                                <v-icon :small="$vuetify.breakpoint.smAndDown" v-text="icons.mdiAccountMultiplePlus"></v-icon>
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>
                </v-row>-->

        <v-divider v-if="haveUsers" class="mb-5"></v-divider>
        <v-row v-if="haveUsers" class="mb-3 expansion-panel-top-wrapper position-relative">
            <v-col :class="{ 'px-1': $vuetify.breakpoint.smAndDown }">
                <v-row>
                    <v-col :class="{'sidebar-scrollable': $vuetify.breakpoint.mdAndUp}" cols="12" md="3" sm="4">
                        <div v-if="!allInternetOptions.length && filterText" class="text-left">{{
                                $gettext('No results for your search')
                            }}
                        </div>
                        <v-expansion-panels v-if="allInternetOptions.length" v-model="selectedInternetOptionIndex"
                                            class="tree-panels">
                            <!-- the v-model for v-expansion-panels tracks by index, regardless of what we set as the :key -->
                            <v-expansion-panel v-for="(internetOption, index) in allInternetOptions" :key="index"
                                               class="tree-panel-item">
                                <v-expansion-panel-header class="py-1">
                                    <div class="d-flex align-center">
                                        <v-icon
                                            :class="{ 'rotated': selectedInternetOptionIndex === internetOption.value }"
                                            class="mr-2 expansion-arrow" small>
                                            mdi-chevron-right
                                        </v-icon>

                                        <div class="text-h6 font-weight-regular my-1" v-if="$language.current === 'en_GB'">
                                            {{ internetOption.text2 }}
                                        </div>
                                        <div class="text-h6 font-weight-regular my-1" v-if="$language.current === 'fr_FR'">
                                            {{ internetOption.frText2 }}
                                        </div>
                                        <div class="text-h6 font-weight-regular my-1" v-if="$language.current === 'it_IT'">
                                            {{ internetOption.itText2 }}
                                        </div>
                                        <v-spacer></v-spacer>
                                        <div class="text-right" style="float: right;">
                                            <v-btn-toggle v-model="userGroupTabFilter" class="text-right" multiple>
                                                <v-btn :fab="$vuetify.breakpoint.smAndDown"
                                                       :small="$vuetify.breakpoint.smAndDown"
                                                       :title="$gettext('Add user group')" icon plain small
                                                       @click.native.stop="openAddCategoryDialog(internetOption.value)">
                                                    <v-icon :small="$vuetify.breakpoint.smAndDown"
                                                            v-text="icons.mdiAccountMultiplePlus"></v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </div>
                                    </div>
                                </v-expansion-panel-header>

                                <v-expansion-panel-content>
                                    <div class="pl-4">

                                        <v-expansion-panels v-model="categoryIndexExpansionPanel" class="tree-panels">

                                            <v-expansion-panel
                                                v-for="(category, categoryIndex) in filterUsersByInternetOption(internetOption?.value)"
                                                :key="categoryIndex" class="tree-panel-item">

                                                <v-expansion-panel-header class="py-1">
                                                    <div class="d-flex align-center">
                                                        <v-icon
                                                            :class="{ 'rotated': categoryIndexExpansionPanel?.[internetOption?.value] === categoryIndex }"
                                                            class="mr-2 expansion-arrow" small>
                                                            mdi-chevron-right
                                                        </v-icon>
                                                        <span class="text-h6 font-weight-light">{{
                                                                category?.key
                                                            }}</span>
                                                        <v-spacer></v-spacer>
                                                        <v-menu>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn :title="$gettext('Tap to view context options')"
                                                                       icon v-bind="attrs" v-on="on">
                                                                    <v-icon small
                                                                            v-text="icons.mdiDotsVertical"></v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <v-list dense>
                                                                <v-list-item class="cursor-pointer"
                                                                             @click="openAddUserUnderCategoryDialog(category.key)">
                                                                    <v-list-item-title>
                                                                        <v-icon class="mr-1" size="18"
                                                                                v-text="icons.mdiAccountPlusOutline"></v-icon>
                                                                        <span>{{ $gettext('Add User') }}</span>
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                                <v-list-item class="cursor-pointer"
                                                                             @click="openEditUserGroup(category)">
                                                                    <v-list-item-title>
                                                                        <v-icon class="mr-1" size="18"
                                                                                v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                        <span>{{ $gettext('Edit') }}</span>
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                                <v-list-item class="cursor-pointer"
                                                                             @click="deleteCategory(category.key)">
                                                                    <v-list-item-title>
                                                                        <v-icon class="mr-1" size="18"
                                                                                v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                        <span>{{ $gettext('Delete') }}</span>
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                                <v-divider></v-divider>
                                                                <v-list-item class="cursor-pointer">
                                                                    <v-list-item-title>
                                                                        <v-icon class="mr-1" size="18"
                                                                                v-text="icons.mdiInformationOutline"></v-icon>
                                                                        <span>{{ $gettext('Users') }}</span>:
                                                                        {{ currentUserCountForUserGroup(category) }}
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>

                                                    </div>
                                                </v-expansion-panel-header>

                                                <v-expansion-panel-content>

                                                    <div class="pl-4">
                                                        <v-expansion-panels v-model="userExpansionPanelIndex"
                                                                            class="tree-panels">
                                                            <v-expansion-panel
                                                                v-for="(user, userIndex) in filteredUsers(category)"
                                                                :key="userIndex" class="tree-panel-item"
                                                                @change="handleUserExpansion(category, user, userIndex)">

                                                                <!------------------------------------------------
                                                                    This font weight regular removes the toggle effect when deselect happens
                                                                ------------------------------------------------->

                                                                <v-expansion-panel-header
                                                                    :class="{ 'font-weight-regular': userExpansionPanelIndex === userIndex }"
                                                                    class="py-1">
                                                                    <div class="d-flex align-center">
                                                                        <v-icon v-if="!isUser(user)"
                                                                                :class="{ 'rotated': userExpansionPanelIndex[`${internetOption?.value}-${categoryIndex}`] === userIndex }"
                                                                                class="mr-2 expansion-arrow" small>
                                                                            mdi-chevron-right
                                                                        </v-icon>
                                                                        <span :class="{ 'ml-2': isUser(user) }"
                                                                              class="body-2">
                                                                            {{ user?.key }}
                                                                        </span>
                                                                        <v-spacer></v-spacer>
                                                                        <v-menu>
                                                                            <template v-slot:activator="{ on, attrs }">
                                                                                <v-btn
                                                                                    :title="$gettext('Edit or delete a user')"
                                                                                    icon v-bind="attrs" v-on="on">
                                                                                    <v-icon small
                                                                                            v-text="icons.mdiDotsHorizontal"></v-icon>
                                                                                </v-btn>
                                                                            </template>
                                                                            <v-list dense>
                                                                                <v-list-item class="cursor-pointer"
                                                                                             @click="openEditUser(category.key, user.key, user.value)">
                                                                                    <v-list-item-title>
                                                                                        <v-icon class="mr-2" size="18"
                                                                                                v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                                        {{ $gettext('Edit User') }}
                                                                                    </v-list-item-title>
                                                                                </v-list-item>
                                                                                <v-list-item class="cursor-pointer"
                                                                                             @click="deleteUser(category.key, user.key)">
                                                                                    <v-list-item-title>
                                                                                        <v-icon class="mr-2" size="18"
                                                                                                v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                                        {{ $gettext('Delete User') }}
                                                                                    </v-list-item-title>
                                                                                </v-list-item>
                                                                            </v-list>
                                                                        </v-menu>
                                                                    </div>
                                                                </v-expansion-panel-header>

                                                                <v-expansion-panel-content>
                                                                    <div class="pl-4">
                                                                    </div>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>

                    <!------------------------------------------------
                        Right Side
                    ------------------------------------------------->

                    <v-col v-if="typeof userExpansionPanelIndex === 'number' && user">
                        <v-row class="my-3">
                            <v-col class="text-left" cols="12">

                                <v-row>
                                    <v-col class="mb-2">
                                        <div class="text-h4">
                                            {{ user.key }}
                                        </div>
                                    </v-col>
                                    <v-col class="text-right mr-4">
                                        <v-btn icon @click="openEditUser(selectedCategory, user.key, user.value)">
                                            <v-icon :title="$gettext('Edit User')" class="my-2 mr-1 cursor-pointer"
                                                    v-text="icons.mdiPencilCircleOutline">
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <v-divider :class="{ 'primary lighten-2': isDark }" class="mb-4"/>
                                <!------------------------------------------------
                                    Login
                                ------------------------------------------------->

                                <v-row class="d-flex mx-1">
                                    <v-col class="text-h6 text-left" v-text="$gettext('Credentials')"></v-col>
                                    <!--                                    <v-col class="text-right">

                                                                            <v-btn v-if="user.value.login?.length" icon
                                                                                   @click="openAddEditCredentialsDialog(user.value.login, user.value.password, 'edit')"
                                                                            >
                                                                                <v-icon
                                                                                    :title="$gettext('Edit credentials')"
                                                                                    class="my-2 mr-1 cursor-pointer"
                                                                                    v-text="icons.mdiPencilCircleOutline"
                                                                                >
                                                                                </v-icon>
                                                                            </v-btn>
                                                                            <v-btn v-else icon
                                                                                   @click="openAddEditCredentialsDialog('', '', 'add')"
                                                                            >
                                                                                <v-icon
                                                                                    :title="$gettext('Add credentials')"
                                                                                    class="my-2 mr-1 cursor-pointer"
                                                                                    v-text="icons.mdiPlusCircleOutline"
                                                                                >
                                                                                </v-icon>
                                                                            </v-btn>
                                                                        </v-col>-->
                                </v-row>

                                <v-divider :class="{ 'primary lighten-2': isDark }" class="mb-2"/>

                                <v-row class="d-flex mx-1">
                                    <v-col>

                                        <v-radio-group v-model="userCredentialsView" hide-details row>
                                            <v-radio :label="$gettext('By Login/Password')" :value="'login'"></v-radio>
                                            <!--                                            <v-radio :label="$gettext('By Computer')" :value="'devices'"></v-radio>-->
                                            <v-radio :label="$gettext('Permanent Permission')"
                                                     :value="'devices'"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>

                                <v-row v-if="userCredentialsView === 'login'">
                                    <v-col>
                                        <v-row v-if="user.value.login?.length" class="mx-1 mt-0 mb-2">
                                            <v-col class="text-left py-2" cols="12">

                                                <v-icon :color="''" :title="''" class="pr-2"
                                                        v-text="icons.mdiAccountCircle"></v-icon>

                                                <span class="cursor-move" v-text="user.value.login"></span>

                                            </v-col>
                                            <v-col class="text-left py-2" cols="12">

                                                <v-icon :color="''" :title="''" class="pr-2"
                                                        v-text="icons.mdiKeyOutline"></v-icon>

                                                <span class="cursor-move" v-text="user.value.password"></span>

                                            </v-col>
                                        </v-row>

                                        <a v-if="user.value.login?.length" class="ml-4"
                                           @click="openAddEditCredentialsDialog(user.value.login, user.value.password, 'edit')">

                                            <v-icon :title="$gettext('Edit Credentials')"
                                                    class="my-2 mr-1 cursor-pointer"
                                                    v-text="icons.mdiPencilCircleOutline">
                                            </v-icon>

                                            {{
                                                $gettext('Edit Credentials')
                                            }}</a>
                                        <a v-else class="ml-4"
                                           @click.prevent.stop="openAddEditCredentialsDialog('', '', 'add')">

                                            <v-icon :title="$gettext('Add Credentials')"
                                                    class="my-2 mr-1 cursor-pointer"
                                                    v-text="icons.mdiPlusCircleOutline">
                                            </v-icon>
                                            {{
                                                $gettext('Add Credentials')
                                            }}</a>

                                    </v-col>
                                </v-row>

                                <v-row
                                    v-else-if="userCredentialsView === 'devices' && user">
                                    <v-col>

                                        <draggable :list="getDevicesFromInput(user?.value?.devices)"
                                                   :options="{ disabled: $vuetify.breakpoint.smAndDown }" class="mb-2"
                                                   @end="draggableDragEnd($event)" @start="draggableDragStart($event)">
                                            <v-hover v-for="(device) in getDevicesFromInput(user?.value?.devices)"
                                                     v-if="typeof user?.value?.devices === 'object' && getDevicesFromInput(user?.value?.devices)['length'] > 0"
                                                     :key="device.key"
                                                     v-slot="{ hover }">

                                                <v-row :style="draggableCursorMoveWhenDragged" class="mx-1 my-0">
                                                    <v-col class="text-left py-2" cols="9">
                                                        <v-icon :title="equipmentTitle(device)" class="pr-2"
                                                                v-text="getIconForTheDevice(device)"></v-icon>

                                                        <span class="cursor-move" v-text="device.key"></span>
                                                    </v-col>
                                                    <v-col class="text-right py-2" cols="3">
                                                        <v-menu>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn :title="$gettext('Edit or delete an equipment')"
                                                                       icon small v-bind="attrs" v-on="on">
                                                                    <v-icon v-text="icons.mdiDotsHorizontal"></v-icon>
                                                                </v-btn>
                                                            </template>

                                                            <v-list dense>
                                                                <v-list-item class="cursor-pointer"
                                                                             @click="openAddEditDeviceDialog(selectedCategory, user?.key, 'edit', device.key, device.value.mac, device.value.active)">
                                                                    <v-list-item-title>
                                                                        <v-icon class="mr-2" size="18"
                                                                                v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                        {{ $gettext('Edit') }}
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                                <v-list-item class="cursor-pointer"
                                                                             @click="deleteUserNode(selectedCategory, user?.key, device.key, 'devices', $gettext('Equipment'))">
                                                                    <v-list-item-title>
                                                                        <v-icon class="mr-2" size="18"
                                                                                v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                        {{ $gettext('Delete') }}
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>
                                                    </v-col>
                                                </v-row>
                                            </v-hover>
                                        </draggable>

                                        <a class="ml-4"
                                           @click="openAddEditDeviceDialog(selectedCategory, user?.key, 'add')">

                                            <v-icon :title="$gettext('Add an equipment')"
                                                    class="my-2 mr-1 cursor-pointer"
                                                    v-text="icons.mdiPlusCircleOutline">
                                            </v-icon>
                                            {{
                                                $gettext('Add Computer')
                                            }}
                                        </a>

                                    </v-col>
                                </v-row>

                                <!-- We will not show this on the server as it's not useful there -->
                                <v-btn v-if="!connectionsIsEnabled" class="primary ml-6 my-4"
                                       small
                                       @click="processAddPermanentPermissions()">
                                    {{ $gettext('Add Permanent Permissions') }}
                                </v-btn>

                                <!------------------------------------------------
                                    Computers
                                ------------------------------------------------->

                                <!--                                <v-row class="d-flex mx-1">
                                                                    <v-col class="text-h6"
                                                                           v-text="$gettext('Computers')"></v-col>
                                                                    <v-col class="text-right">
                                                                        <v-btn icon>
                                                                            <v-icon :title="$gettext('Add an equipment')"
                                                                                    class="my-2 mr-1 cursor-pointer"
                                                                                    @click="openAddEditDeviceDialog(selectedCategory, user?.key, 'add')"
                                                                                    v-text="icons.mdiPlusCircle">
                                                                            </v-icon>
                                                                        </v-btn>
                                                                    </v-col>
                                                                </v-row>-->
                                <!--                                <v-divider :class="{ 'primary lighten-2': isDark }"-->
                                <!--                                           class="mb-4"/>-->
                                <!--                                                            user.value?.devices?.length > 0-->
                                <!--                                <v-row
                                                                    v-if="user && getDevicesFromInput(user?.value?.devices)['length'] > 0">
                                                                    <v-col>

                                                                        &lt;!&ndash;                                                                    v-model="user.value.devices"&ndash;&gt;

                                                                        <draggable
                                                                            :list="getDevicesFromInput(user?.value?.devices)"
                                                                            :options="{ disabled: $vuetify.breakpoint.smAndDown }"
                                                                            @end="draggableDragEnd($event)"
                                                                            @start="draggableDragStart($event)">
                                                                            &lt;!&ndash;                                                                            v-for="(device) in user.value.devices"&ndash;&gt;
                                                                            <v-hover
                                                                                v-for="(device) in getDevicesFromInput(user?.value?.devices)"
                                                                                v-if="typeof user?.value?.devices === 'object'"
                                                                                :key="device.key"
                                                                                v-slot="{ hover }">

                                                                                <v-row
                                                                                    :style="draggableCursorMoveWhenDragged"
                                                                                    class="mx-1 my-0">
                                                                                    <v-col class="text-left py-2" cols="9">

                                                                                        &lt;!&ndash;                                                            :color="device.value.active !== 1 ? 'grey' : ''"&ndash;&gt;
                                                                                        <v-icon
                                                                                            :title="equipmentTitle(device)"
                                                                                            class="pr-2"
                                                                                            v-text="getIconForTheDevice(device)"></v-icon>

                                                                                        <span class="cursor-move"
                                                                                              v-text="device.key"></span>
                                                                                    </v-col>
                                                                                    <v-col class="text-right py-2" cols="3">
                                                                                        <v-menu>
                                                                                            <template
                                                                                                v-slot:activator="{ on, attrs }">
                                                                                                <v-btn
                                                                                                    :title="$gettext('Edit or delete an equipment')"
                                                                                                    icon
                                                                                                    small v-bind="attrs"
                                                                                                    v-on="on">
                                                                                                    <v-icon
                                                                                                        v-text="icons.mdiDotsHorizontal"></v-icon>
                                                                                                </v-btn>
                                                                                            </template>

                                                                                            <v-list dense>
                                                                                                <v-list-item
                                                                                                    class="cursor-pointer"
                                                                                                    @click="openAddEditDeviceDialog(selectedCategory, user?.key, 'edit', device.key, device.value.mac, device.value.active)">
                                                                                                    <v-list-item-title>
                                                                                                        <v-icon class="mr-2"
                                                                                                                size="18"
                                                                                                                v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                                                        {{
                                                                                                            $gettext('Edit')
                                                                                                        }}
                                                                                                    </v-list-item-title>
                                                                                                </v-list-item>
                                                                                                <v-list-item
                                                                                                    class="cursor-pointer"
                                                                                                    @click="deleteUserNode(selectedCategory, user?.key, device.key, 'devices', $gettext('Equipment'))">
                                                                                                    <v-list-item-title>
                                                                                                        <v-icon class="mr-2"
                                                                                                                size="18"
                                                                                                                v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                                                        {{
                                                                                                            $gettext('Delete')
                                                                                                        }}
                                                                                                    </v-list-item-title>
                                                                                                </v-list-item>
                                                                                            </v-list>
                                                                                        </v-menu>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-hover>
                                                                        </draggable>
                                                                    </v-col>
                                                                </v-row>-->
                                <!--                                <v-row v-else class="mx-1 mb-4">
                                                                    <v-col>
                                                                        <div>
                                                                            <span
                                                                                v-text="$gettextInterpolate($gettext('We don\'t have any computer devices for %{user} yet.'), { user: user?.key })"></span>
                                                                            <a :class="{ 'primary&#45;&#45;text text&#45;&#45;lighten-4': isDark }"
                                                                               class="pl-1"
                                                                               v-text="$gettext('Create One')"
                                                                               @click.stop="openAddEditDeviceDialog(selectedCategory, user?.key, 'add')"></a>.
                                                                        </div>
                                                                    </v-col>
                                                                </v-row>-->


                                <!------------------------------------------------
                                    Mobiles/Phone
                                ------------------------------------------------->

                                <v-row class="d-flex mx-1">
                                    <v-col class="text-h6" v-text="$gettext('Mobiles')"></v-col>
                                    <v-col class="text-right">
                                        <v-btn icon
                                               @click="openAddEditDeviceMobileDialog(selectedCategory, user?.key, 'add')">
                                            <v-icon :title="$gettext('Add a phone')" class="my-2 mr-1 cursor-pointer"
                                                    v-text="icons.mdiPlusCircle">
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-divider :class="{ 'primary lighten-2': isDark }" class="mb-4"/>
                                <v-row v-if="getDevicesFromInput(user?.value?.devices, 'mobile')['length'] > 0">
                                    <v-col>

                                        <!--                                                                    v-model="user.value.devices"-->

                                        <draggable :list="getDevicesFromInput(user?.value?.devices, 'mobile')"
                                                   :options="{ disabled: $vuetify.breakpoint.smAndDown }"
                                                   @end="draggableDragEnd($event)" @start="draggableDragStart($event)">
                                            <!--                                                                            v-for="(device) in user.value.devices"-->
                                            <v-hover
                                                v-for="(device) in getDevicesFromInput(user?.value?.devices, 'mobile')"
                                                v-if="typeof user?.value?.devices === 'object'" :key="device.key"
                                                v-slot="{ hover }">

                                                <v-row :style="draggableCursorMoveWhenDragged" class="mx-1 my-0">
                                                    <v-col class="text-left py-2" cols="9">

                                                        <!--                                                            :color="device.value.active !== 1 ? 'grey' : ''"-->
                                                        <v-icon :title="equipmentTitle(device)" class="pr-2"
                                                                v-text="getIconForTheDevice(device)"></v-icon>

                                                        <span class="cursor-move" v-text="device.key"></span>

                                                    </v-col>
                                                    <v-col class="text-right py-2" cols="3">
                                                        <v-menu>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn :title="$gettext('Edit or delete an equipment')"
                                                                       icon small v-bind="attrs" v-on="on">
                                                                    <v-icon v-text="icons.mdiDotsHorizontal"></v-icon>
                                                                </v-btn>
                                                            </template>

                                                            <v-list dense>
                                                                <v-list-item class="cursor-pointer"
                                                                             @click="openManageAppsDialog({ group: selectedCategory, user: user?.key, device: device.key })">
                                                                    <v-list-item-title>
                                                                        <v-icon class="mr-2" size="18"
                                                                                v-text="icons.mdiApps"></v-icon>
                                                                        {{
                                                                            $gettext('Manage Apps')
                                                                        }}
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                                <v-list-item class="cursor-pointer"
                                                                             @click="openAddEditDeviceMobileDialog(selectedCategory, user?.key, 'edit', device.key, device.value.active)">
                                                                    <v-list-item-title>
                                                                        <v-icon class="mr-2" size="18"
                                                                                v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                        {{
                                                                            $gettext('Edit')
                                                                        }}
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                                <v-list-item class="cursor-pointer"
                                                                             @click="deleteMobileEquipmentAndConfiguration(selectedCategory, user?.key, device.key, 'devices', $gettext('Mobile'))">
                                                                    <v-list-item-title>
                                                                        <v-icon class="mr-2" size="18"
                                                                                v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                        {{
                                                                            $gettext('Delete')
                                                                        }}
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>
                                                    </v-col>
                                                </v-row>
                                            </v-hover>
                                        </draggable>
                                    </v-col>
                                </v-row>
                                <v-row v-else class="mx-1 mb-4">
                                    <v-col>
                                        <div>
                                            <span
                                                v-text="$gettextInterpolate($gettext('We don\'t have any mobile devices for %{user} yet.'), { user: user?.key })"></span>
                                            <a :class="{ 'primary--text text--lighten-4': isDark }" class="pl-1"
                                               v-text="$gettext('Create One')"
                                               @click.stop="openAddEditDeviceMobileDialog(selectedCategory, user?.key, 'add')"></a>.
                                        </div>
                                    </v-col>
                                </v-row>

                                <!------------------------------------------------
                                    Special Permissions
                                ------------------------------------------------->

                                <!--                                &ndash;&gt;{{ selectedUserAccountType }}-->
                                <!--                                {{ users[selectedCategoryIndex].value[selectedUserIndex].value }}-->

                                <v-row v-if="selectedUserAccountType.length" class="d-flex mx-1">
                                    <v-col class="text-h6" v-text="$gettext('Special Permissions')"></v-col>
                                    <v-col class="text-right">
                                        <v-btn v-if="!isEditSpecialPermissions" icon
                                               @click="isEditSpecialPermissions = true">
                                            <v-icon :title="$gettext('Edit Special Permissions')"
                                                    class="my-2 mr-1 cursor-pointer"
                                                    v-text="icons.mdiPencilCircleOutline">
                                            </v-icon>
                                        </v-btn>
                                        <v-btn v-else icon @click="isEditSpecialPermissions = false">
                                            <v-icon :title="$gettext('Cancel edit of special permissions')"
                                                    class="my-2 mr-1 cursor-pointer" v-text="icons.mdiCloseCircle">
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-divider v-if="selectedUserAccountType.length"
                                           :class="{ 'primary lighten-2': isDark }" class="mb-4"/>
                                <v-row v-if="selectedUserAccountType.length" class="mb-5">
                                    <v-col>
                                        <v-select v-if="isEditSpecialPermissions" v-model="selectedUserAccountType"
                                                  :items="userDeviceKindOptions" :label="$gettext('Account Type')"
                                                  :placeholder="$gettext('Account Type')" item-text="text"
                                                  item-value="value"
                                                  outlined></v-select>

                                        <v-row v-else-if="!isEditSpecialPermissions" class="ml-2">
                                            <v-col>
                                                <div>
                                                    {{ $gettext('The account type is') }} {{ selectedUserAccountType }}
                                                </div>
                                                <div v-if="selectedUserAccountType === 'shared'">
                                                    {{ $gettext('The suffix is') }} {{ selectedUserSuffix }}
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-col>
                                    <v-col v-if="isEditSpecialPermissions">
                                        <v-text-field v-if="selectedUserAccountType === 'shared'"
                                                      v-model="selectedUserSuffix"
                                                      :hint="$gettext('This is an advanced feature. Let this be blank if unsure. This field is a suffix for special permissions')"
                                                      :label="$gettext('Suffix')" :placeholder="$gettext('Suffix')"
                                                      outlined
                                                      persistent-hint></v-text-field>
                                    </v-col>
                                </v-row>


                                <!------------------------------------------------
                                    Category/Profile
                                ------------------------------------------------->

                                <v-row class="d-flex mx-1">
                                    <v-col class="text-h6" v-text="$gettext('Category Profile')"></v-col>
                                    <v-col class="text-right">
                                        <v-btn icon @click="openEditUser(selectedCategory, user?.key, user.value)">
                                            <v-icon :title="$gettext('Edit User')" class="my-2 mr-1 cursor-pointer"
                                                    v-text="icons.mdiPencilCircleOutline">
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-divider :class="{ 'primary lighten-2': isDark }" class="mb-4"/>
                                <v-row class="ml-2">
                                    <v-col>
                                        {{ user.value['categories_profile'] || $gettext('No profile on user level') }}
                                    </v-col>
                                </v-row>

                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col v-else-if="!filterText">
                        <p class="subtitle-1">
                            {{
                                $gettext('Once a user is selected from the left panel, it\'s details will be displayed over here.')
                            }}
                        </p>
                    </v-col>
                </v-row>


                <!--                <draggable v-model="users" :component-data="componentDataForUserGroup"
                                           :options="{ disabled: $vuetify.breakpoint.smAndDown }"
                                           class="w-100" tag="v-expansion-panels"
                                           @end="draggableDragEndForUserGroup($event)"
                                           @start="draggableDragStart($event)">
                                    <v-expansion-panel v-for="(category, categoryIndex) in users"
                                                       v-if="checkEachCategory(category, categoryIndex)"
                                                       :key='categoryIndex'
                                                       @click="categoryPanelClicked(categoryIndex)">
                                        <v-expansion-panel-header :style="draggableCursorMoveWhenDragged">
                                            <template v-slot:default="{ open }">
                                                <v-hover v-slot="{ hover }">
                                                    <v-row>
                                                        <v-col
                                                            class="px-0 icon-size-sm cursor-pointer text-truncate d-flex align-center"
                                                            cols="8" md="9"
                                                            sm="8">
                                                            <v-tooltip bottom color="red">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn v-show="isAtInternetValueForCategory(category) === 'none'"
                                                                           :small="$vuetify.breakpoint.smAndDown" icon
                                                                           v-bind="attrs"
                                                                           v-on="on">
                                                                        <v-icon class="color-red mr-1"
                                                                                v-text="icons.mdiWebCancel"></v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span class="subtitle-1 font-weight-bold">
                                                                    <v-icon class="mr-2" color="white"
                                                                            v-text="icons.mdiCloseCircle"></v-icon>
                                                                    <span v-text="$gettext('No internet connection')"></span>
                                                                </span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom color="secondary">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn v-show="isAtInternetValueForCategory(category) === 'open'"
                                                                           :small="$vuetify.breakpoint.smAndDown" icon
                                                                           v-bind="attrs"
                                                                           v-on="on">
                                                                        <v-icon class="color-blue mr-1"
                                                                                v-text="icons.mdiWebMinus"></v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span class="subtitle-1 font-weight-bold">
                                                                    <v-icon class="mr-2" color="white"
                                                                            v-text="icons.mdiCheckCircle"></v-icon>
                                                                    <span>{{
                                                                            $gettext('Open internet connection - Applies to Categories')
                                                                        }}</span>
                                                                </span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom color="primary">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn
                                                                        v-show="isAtInternetValueForCategory(category) === 'filtered'"
                                                                        :small="$vuetify.breakpoint.smAndDown" icon
                                                                        v-bind="attrs"
                                                                        v-on="on">
                                                                        <v-icon class="color-green mr-1"
                                                                                v-text="icons.mdiWebCheck"></v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span class="subtitle-1 font-weight-bold">
                                                                    <v-icon class="mr-2" color="white"
                                                                            v-text="icons.mdiFilterCheck"></v-icon>
                                                                    <span>{{
                                                                            $gettext('Filtered connection - Applies to rules and categories')
                                                                        }}</span>
                                                                </span>
                                                            </v-tooltip>
                                                            <span
                                                                :class="{ 'px-1 my-2': $vuetify.breakpoint.smAndDown, 'px-2 my-4': $vuetify.breakpoint.mdAndUp }"
                                                                class="text-truncate"
                                                                v-text="category.key"></span>
                                                        </v-col>

                                                        <v-col class="pr-3 align-flex-end" cols="4" md="3" sm="4">

                                                            <v-menu>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn :title="$gettext('Tap to view context options')" icon
                                                                           v-bind="attrs"
                                                                           v-on="on">
                                                                        <v-icon v-text="icons.mdiDotsVertical"></v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <v-list dense>
                                                                    <v-list-item class="cursor-pointer"
                                                                                 @click="openAddUserUnderCategoryDialog(category.key)">
                                                                        <v-list-item-title>
                                                                            <v-icon class="mr-1" size="18"
                                                                                    v-text="icons.mdiAccountPlusOutline"></v-icon>
                                                                            <span>{{ $gettext('Add User') }}</span>
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                    <v-list-item class="cursor-pointer"
                                                                                 @click="openEditUserGroup(category)">
                                                                        <v-list-item-title>
                                                                            <v-icon class="mr-1" size="18"
                                                                                    v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                            <span>{{ $gettext('Edit') }}</span>
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                    <v-list-item class="cursor-pointer"
                                                                                 @click="deleteCategory(category.key)">
                                                                        <v-list-item-title>
                                                                            <v-icon class="mr-1" size="18"
                                                                                    v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                            <span>{{ $gettext('Delete') }}</span>
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                    <v-divider></v-divider>
                                                                    <v-list-item class="cursor-pointer">
                                                                        <v-list-item-title>
                                                                            <v-icon class="mr-1" size="18"
                                                                                    v-text="icons.mdiInformationOutline"></v-icon>
                                                                            <span>{{ $gettext('Users') }}</span>:
                                                                            {{ currentUserCountForUserGroup(category) }}
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                        </v-col>
                                                    </v-row>
                                                </v-hover>
                                            </template>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="expansion-panel-content-border user-expansions">
                                            <v-row v-if="userPrivateAttributes.length > 2" class="mx-1">
                                                <v-col class="pa-0 pa-sm-2" cols="12">
                                                    <draggable v-model="category.value"
                                                               :options="{ disabled: $vuetify.breakpoint.smAndDown }"
                                                               @end="draggableDragEnd($event)"
                                                               @start="draggableDragStart($event)">
                                                        <v-expansion-panels v-for="(user) in category.value"
                                                                            v-if="checkEachUser(category.key, user.key, categoryIndex)"
                                                                            :key="user.key"
                                                                            v-model="userPanel['' + user.key]"
                                                                            accordion
                                                                            class="my-4">
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-header :color="isDark ? 'primary darken-4' : ''"
                                                                                          :style="draggableCursorMoveWhenDragged"
                                                                                          expand-icon="mdi-menu-down">
                                                                    <template v-slot:default="{ open }">
                                                                        <v-row class="d-flex align-center">
                                                                            <v-col class="text-left cursor-pointer" cols="9"
                                                                                   @click="selectChildUser(category.key, user.key)">
                                                                                <div>
                                                                                    <v-tooltip bottom color="primary">
                                                                                        <template v-slot:activator="{ on, attrs }">
                                                                                            <v-icon
                                                                                                v-if="user && user.value.hasOwnProperty('subusers') && user.value.subusers"
                                                                                                class="pr-2"
                                                                                                v-bind="attrs"
                                                                                                v-on="on"
                                                                                                v-text="icons.mdiAccountSupervisorCircle"></v-icon>
                                                                                            <v-icon v-else class="pr-2"
                                                                                                    v-bind="attrs"
                                                                                                    v-on="on"
                                                                                                    v-text="icons.mdiAccountCircle"></v-icon>
                                                                                        </template>
                                                                                        <span>{{ iconHoverText(user) }}</span>
                                                                                    </v-tooltip>
                                                                                    <span class="text-truncate"
                                                                                          v-text="user.key"></span>
                                                                                </div>
                                                                            </v-col>
                                                                            <v-col class="text-right" cols="3">
                                                                                <v-menu>
                                                                                    <template v-slot:activator="{ on, attrs }">
                                                                                        <v-btn
                                                                                            :title="$gettext('Edit or delete a user')"
                                                                                            icon v-bind="attrs"
                                                                                            v-on="on">
                                                                                            <v-icon
                                                                                                v-text="icons.mdiDotsHorizontal"></v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <v-list dense>
                                                                                        <v-list-item
                                                                                            class="cursor-pointer"
                                                                                            @click="openEditUser(category.key, user.key, user.value)">
                                                                                            <v-list-item-title>
                                                                                                <v-icon class="mr-2" size="18"
                                                                                                        v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                                                {{ $gettext('Edit User') }}
                                                                                            </v-list-item-title>
                                                                                        </v-list-item>
                                                                                        <v-list-item
                                                                                            class="cursor-pointer"
                                                                                            @click="deleteUser(category.key, user.key)">
                                                                                            <v-list-item-title>
                                                                                                <v-icon class="mr-2" size="18"
                                                                                                        v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                                                {{ $gettext('Delete User') }}
                                                                                            </v-list-item-title>
                                                                                        </v-list-item>
                                                                                    </v-list>
                                                                                </v-menu>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content :class="{ 'darken-2': isDark }"
                                                                                           :color="isDark ? 'primary' : ''">
                                                                    <v-row class="my-3">
                                                                        <v-col class="text-left" cols="12" md="6">

                                                                            <v-row class="d-flex mx-1">
                                                                                <v-col class="text-h6"
                                                                                       v-text="$gettext('Computers')"></v-col>
                                                                                <v-col class="text-right">
                                                                                    <v-btn icon>
                                                                                        <v-icon :title="$gettext('Add an equipment')"
                                                                                                class="my-2 mr-1 cursor-pointer"
                                                                                                @click="openAddEditDeviceDialog(category.key, user.key, 'add')"
                                                                                                v-text="icons.mdiPlusCircle">
                                                                                        </v-icon>
                                                                                    </v-btn>
                                                                                </v-col>
                                                                            </v-row>
                                                                            <v-divider :class="{ 'primary lighten-2': isDark }"
                                                                                       class="mb-4"/>
                                                                            <v-row
                                                                                v-if="getDevicesFromInput(user?.value?.devices)['length'] > 0">
                                                                                <v-col>

                                                                                    <draggable
                                                                                        :list="getDevicesFromInput(user.value.devices)"
                                                                                        :options="{ disabled: $vuetify.breakpoint.smAndDown }"
                                                                                        @end="draggableDragEnd($event)"
                                                                                        @start="draggableDragStart($event)">
                                                                                        <v-hover
                                                                                            v-for="(device) in getDevicesFromInput(user.value.devices)"
                                                                                            v-if="typeof user.value.devices === 'object'"
                                                                                            :key="device.key"
                                                                                            v-slot="{ hover }">

                                                                                            <v-row
                                                                                                :style="draggableCursorMoveWhenDragged"
                                                                                                class="mx-1 my-0">
                                                                                                <v-col class="text-left py-2" cols="9">

                                                                                                    <v-icon
                                                                                                        :color="device.value.active !== 1 ? 'grey' : ''"
                                                                                                        :title="equipmentTitle(device)"
                                                                                                        class="pr-2"
                                                                                                        v-text="getIconForTheDevice(device)"></v-icon>

                                                                                                    <span class="cursor-move"
                                                                                                          v-text="device.key"></span>
                                                                                                </v-col>
                                                                                                <v-col class="text-right py-2" cols="3">
                                                                                                    <v-menu>
                                                                                                        <template
                                                                                                            v-slot:activator="{ on, attrs }">
                                                                                                            <v-btn
                                                                                                                :title="$gettext('Edit or delete an equipment')"
                                                                                                                icon
                                                                                                                small v-bind="attrs"
                                                                                                                v-on="on">
                                                                                                                <v-icon
                                                                                                                    v-text="icons.mdiDotsHorizontal"></v-icon>
                                                                                                            </v-btn>
                                                                                                        </template>

                                                                                                        <v-list dense>
                                                                                                            <v-list-item
                                                                                                                class="cursor-pointer"
                                                                                                                @click="openAddEditDeviceDialog(category.key, user.key, 'edit', device.key, device.value.mac, device.value.active)">
                                                                                                                <v-list-item-title>
                                                                                                                    <v-icon class="mr-2"
                                                                                                                            size="18"
                                                                                                                            v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                                                                    {{
                                                                                                                        $gettext('Edit')
                                                                                                                    }}
                                                                                                                </v-list-item-title>
                                                                                                            </v-list-item>
                                                                                                            <v-list-item
                                                                                                                class="cursor-pointer"
                                                                                                                @click="deleteUserNode(category.key, user.key, device.key, 'devices', $gettext('Equipment'))">
                                                                                                                <v-list-item-title>
                                                                                                                    <v-icon class="mr-2"
                                                                                                                            size="18"
                                                                                                                            v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                                                                    {{
                                                                                                                        $gettext('Delete')
                                                                                                                    }}
                                                                                                                </v-list-item-title>
                                                                                                            </v-list-item>
                                                                                                        </v-list>
                                                                                                    </v-menu>
                                                                                                </v-col>
                                                                                            </v-row>
                                                                                        </v-hover>
                                                                                    </draggable>
                                                                                </v-col>
                                                                            </v-row>
                                                                            <v-row v-else class="mx-1 mb-4">
                                                                                <v-col>
                                                                                    <div>
                                                                                        <span
                                                                                            v-text="$gettextInterpolate($gettext('We don\'t have any computer devices for %{user} yet.'), { user: user.key })"></span>
                                                                                        <a :class="{ 'primary&#45;&#45;text text&#45;&#45;lighten-4': isDark }"
                                                                                           class="pl-1"
                                                                                           v-text="$gettext('Create One')"
                                                                                           @click.stop="openAddEditDeviceDialog(category.key, user.key, 'add')"></a>.
                                                                                    </div>
                                                                                </v-col>
                                                                            </v-row>


                                                                            <v-row class="d-flex mx-1">
                                                                                <v-col class="text-h6"
                                                                                       v-text="$gettext('Mobiles')"></v-col>
                                                                                <v-col class="text-right">
                                                                                    <v-btn icon
                                                                                           @click="openAddEditDeviceMobileDialog(category.key, user.key, 'add')">
                                                                                        <v-icon :title="$gettext('Add a phone')"
                                                                                                class="my-2 mr-1 cursor-pointer"
                                                                                                v-text="icons.mdiPlusCircle">
                                                                                        </v-icon>
                                                                                    </v-btn>
                                                                                </v-col>
                                                                            </v-row>
                                                                            <v-divider :class="{ 'primary lighten-2': isDark }"
                                                                                       class="mb-4"/>
                                                                            <v-row
                                                                                v-if="getDevicesFromInput(user?.value?.devices, 'mobile')['length'] > 0">
                                                                                <v-col>


                                                                                    <draggable
                                                                                        :list="getDevicesFromInput(user.value.devices, 'mobile')"
                                                                                        :options="{ disabled: $vuetify.breakpoint.smAndDown }"
                                                                                        @end="draggableDragEnd($event)"
                                                                                        @start="draggableDragStart($event)">
                                                                                        <v-hover
                                                                                            v-for="(device) in getDevicesFromInput(user.value.devices, 'mobile')"
                                                                                            v-if="typeof user.value.devices === 'object'"
                                                                                            :key="device.key"
                                                                                            v-slot="{ hover }">

                                                                                            <v-row
                                                                                                :style="draggableCursorMoveWhenDragged"
                                                                                                class="mx-1 my-0">
                                                                                                <v-col class="text-left py-2" cols="9">

                                                                                                    <v-icon
                                                                                                        :color="device.value.active !== 1 ? 'grey' : ''"
                                                                                                        :title="equipmentTitle(device)"
                                                                                                        class="pr-2"
                                                                                                        v-text="getIconForTheDevice(device)"></v-icon>

                                                                                                    <span class="cursor-move"
                                                                                                          v-text="device.key"></span>
                                                                                                </v-col>
                                                                                                <v-col class="text-right py-2" cols="3">
                                                                                                    <v-menu>
                                                                                                        <template
                                                                                                            v-slot:activator="{ on, attrs }">
                                                                                                            <v-btn
                                                                                                                :title="$gettext('Edit or delete an equipment')"
                                                                                                                icon
                                                                                                                small v-bind="attrs"
                                                                                                                v-on="on">
                                                                                                                <v-icon
                                                                                                                    v-text="icons.mdiDotsHorizontal"></v-icon>
                                                                                                            </v-btn>
                                                                                                        </template>

                                                                                                        <v-list dense>
                                                                                                            <v-list-item
                                                                                                                class="cursor-pointer"
                                                                                                                @click="openManageAppsDialog({ group: category.key, user: user.key, device: device.key })">
                                                                                                                <v-list-item-title>
                                                                                                                    <v-icon class="mr-2"
                                                                                                                            size="18"
                                                                                                                            v-text="icons.mdiApps"></v-icon>
                                                                                                                    {{
                                                                                                                        $gettext('Manage Apps')
                                                                                                                    }}
                                                                                                                </v-list-item-title>
                                                                                                            </v-list-item>
                                                                                                            <v-list-item
                                                                                                                class="cursor-pointer"
                                                                                                                @click="openAddEditDeviceMobileDialog(category.key, user.key, 'edit', device.key, device.value.active)">
                                                                                                                <v-list-item-title>
                                                                                                                    <v-icon class="mr-2"
                                                                                                                            size="18"
                                                                                                                            v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                                                                    {{
                                                                                                                        $gettext('Edit')
                                                                                                                    }}
                                                                                                                </v-list-item-title>
                                                                                                            </v-list-item>
                                                                                                            <v-list-item
                                                                                                                class="cursor-pointer"
                                                                                                                @click="deleteMobileEquipmentAndConfiguration(category.key, user.key, device.key, 'devices', $gettext('Equipment'))">
                                                                                                                <v-list-item-title>
                                                                                                                    <v-icon class="mr-2"
                                                                                                                            size="18"
                                                                                                                            v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                                                                    {{
                                                                                                                        $gettext('Delete')
                                                                                                                    }}
                                                                                                                </v-list-item-title>
                                                                                                            </v-list-item>
                                                                                                        </v-list>
                                                                                                    </v-menu>
                                                                                                </v-col>
                                                                                            </v-row>
                                                                                        </v-hover>
                                                                                    </draggable>
                                                                                </v-col>
                                                                            </v-row>
                                                                            <v-row v-else class="mx-1 mb-4">
                                                                                <v-col>
                                                                                    <div>
                                                                                        <span
                                                                                            v-text="$gettextInterpolate($gettext('We don\'t have any mobile devices for %{user} yet.'), { user: user.key })"></span>
                                                                                        <a :class="{ 'primary&#45;&#45;text text&#45;&#45;lighten-4': isDark }"
                                                                                           class="pl-1"
                                                                                           v-text="$gettext('Create One')"
                                                                                           @click.stop="openAddEditDeviceMobileDialog(category.key, user.key, 'add')"></a>.
                                                                                    </div>
                                                                                </v-col>
                                                                            </v-row>


                                                                        </v-col>

                                                                        <v-col class="text-left mb-md-6" cols="12" md="6">
                                                                            <v-row class="d-flex mx-1">
                                                                                <v-col class="text-h6"
                                                                                       v-text="$gettext('Sub Users')"></v-col>
                                                                                <v-col class="text-right">
                                                                                    <v-icon :title="$gettext('Add a sub user')"
                                                                                            class="my-2 mr-1 cursor-pointer"
                                                                                            @click="openAddEditSubUsersDialog(category.key, user.key, 'add')"
                                                                                            v-text="icons.mdiPlusCircle">
                                                                                    </v-icon>
                                                                                </v-col>
                                                                            </v-row>
                                                                            <v-divider :class="{ 'primary lighten-2': isDark }"
                                                                                       class="mb-4"/>
                                                                            <div
                                                                                v-if="user && user.value.hasOwnProperty('subusers') && user.value.subusers && Object.keys(user.value.subusers).length > 0"
                                                                                class="mb-3 px-3">

                                                                                <draggable
                                                                                    v-if="user.value.hasOwnProperty('subusers') && typeof user.value.subusers === 'object'"
                                                                                    v-model="user.value.subusers"
                                                                                    :options="{ disabled: $vuetify.breakpoint.smAndDown }"
                                                                                    class="w-100"
                                                                                    @end="draggableDragEnd($event)"
                                                                                    @start="draggableDragStart($event)"
                                                                                >
                                                                                    <v-hover
                                                                                        v-for="(subUser) in user.value.subusers"
                                                                                        v-if="user.value.hasOwnProperty('subusers') && typeof user.value.subusers === 'object'"
                                                                                        :key="subUser.key"
                                                                                        v-slot="{ hover }">

                                                                                        <v-row
                                                                                            :style="draggableCursorMoveWhenDragged"
                                                                                        >
                                                                                            <v-col class="text-left py-1 ma-auto"
                                                                                                   cols="8">
                                                                                                <v-icon class="pr-2"
                                                                                                        v-text="icons.mdiAccountChildCircle"></v-icon>
                                                                                                <span
                                                                                                    v-text="subUser.key"></span>
                                                                                            </v-col>
                                                                                            <v-col class="text-right py-1"
                                                                                                   cols="4">
                                                                                                <v-menu>
                                                                                                    <template
                                                                                                        v-slot:activator="{ on, attrs }">
                                                                                                        <v-btn
                                                                                                            :title="$gettext('View password, edit, and delete a sub user from here')"
                                                                                                            icon
                                                                                                            v-bind="attrs"
                                                                                                            v-on="on">
                                                                                                            <v-icon
                                                                                                                v-text="icons.mdiDotsHorizontal"></v-icon>
                                                                                                        </v-btn>
                                                                                                    </template>

                                                                                                    <v-list dense>
                                                                                                        <v-list-item
                                                                                                            class="cursor-pointer"
                                                                                                            @click="openAddEditSubUsersDialog(category.key, user.key, 'edit', subUser.key, subUser.value.password)">
                                                                                                            <v-list-item-title>
                                                                                                                <v-icon
                                                                                                                    class="mr-2"
                                                                                                                    size="18"
                                                                                                                    v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                                                                Edit sub
                                                                                                                user
                                                                                                            </v-list-item-title>
                                                                                                        </v-list-item>
                                                                                                        <v-list-item
                                                                                                            class="cursor-pointer"
                                                                                                            @click="deleteUserNode(category.key, user.key, subUser.key, 'subusers', $gettext('Subuser'))">
                                                                                                            <v-list-item-title>
                                                                                                                <v-icon
                                                                                                                    class="mr-2"
                                                                                                                    size="18"
                                                                                                                    v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                                                                Delete sub
                                                                                                                user
                                                                                                            </v-list-item-title>
                                                                                                        </v-list-item>
                                                                                                        <v-list-item>
                                                                                                            <v-list-item-title>
                                                                                                                <v-icon
                                                                                                                    class="mr-2"
                                                                                                                    size="18"
                                                                                                                    v-text="icons.mdiKeyOutline"></v-icon>
                                                                                                                {{
                                                                                                                    subUser.value.password
                                                                                                                }}
                                                                                                            </v-list-item-title>
                                                                                                        </v-list-item>
                                                                                                    </v-list>
                                                                                                </v-menu>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                    </v-hover>
                                                                                </draggable>
                                                                            </div>

                                                                            <div v-else>
                                                                                <v-row class="mx-1 mb-4">
                                                                                    <v-col>
                                                                                        <div class="">{{
                                                                                                $gettextInterpolate($gettext('We don\'t have any sub user for %{ user } yet.'), {user: user.key})
                                                                                            }} <a
                                                                                                :class="{ 'primary&#45;&#45;text text&#45;&#45;lighten-4': isDark }"
                                                                                                @click.stop="openAddEditSubUsersDialog(category.key, user.key, 'add')">{{
                                                                                                    $gettext('Create One')
                                                                                                }}</a>.
                                                                                        </div>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </div>
                                                                        </v-col>

                                                                    </v-row>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </draggable>
                                                </v-col>
                                            </v-row>
                                            <v-row v-else class="mx-1 mt-2 mb-4 text-left">
                                                <v-col>
                                                    <div class="">

                                                        {{
                                                            $gettextInterpolate($gettext('We don\'t have any user for %{ category } yet.'), {
                                                                category: category.key
                                                            })
                                                        }} <a :class="{ 'primary&#45;&#45;text text&#45;&#45;lighten-4': isDark }"
                                                              @click.stop="openAddUserUnderCategoryDialog(category.key)">{{
                                                            $gettext('Create One')
                                                        }}</a>.
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </draggable>-->
            </v-col>
        </v-row>
        <v-row v-else-if="userAutoCompleteFilterValue2 && userAutoCompleteFilterValue2.length > 0" class="mb-0 mt-6">
            <v-col>
                {{
                    $gettextInterpolate($gettext('No users are available for the search term %{ searchedTerm }'), {
                        searchedTerm: userAutoCompleteFilterValue2
                    })
                }}
            </v-col>
        </v-row>
        <v-row v-else class="mb-0 mt-6">
            <v-col>
                {{ $gettext("We don't have any user groups yet.") }} <a @click.stop="openAddCategoryDialog()">{{
                    $gettext('Create a user group')
                }}</a>.
            </v-col>
        </v-row>

        <!------------------------------------------------
            Dialogs
        ------------------------------------------------->

        <!-- There's a small trick here. VDialog does not render mounted each time. Only the first time. We are having v-if here so that makes mounted run each time but there are more reasons to have v-if as well -->
        <dialog-edit-group-name v-if="editCategoryNameDialog" :edit-category-name-dialog="editCategoryNameDialog"
                                :in-edit-category-name="editCategoryNameField"
                                :in-edit-internet-option="editInternetOptionField"
                                :in-edit-profile="editProfileField"
                                @close-edit-category-name-dialog="(dialogName) => { closeDialog(dialogName) }"
                                @user-group-edited="((newCategoryName, internetOption, editProfile) => { processEditUserGroup(newCategoryName, internetOption, editProfile) })"></dialog-edit-group-name>

        <dialog-edit-user
            v-if="editUserNameDialog && editUserNameField && editUserNameField.length > 0 && editUserNameCategoryParent"
            :edit-user-name-dialog="editUserNameDialog" :in-edit-all-user-groups="users.map(user => user.key)"
            :in-edit-login="editLoginField" :in-edit-password="editPasswordField"
            :in-edit-profile="editUserProfileField" :in-edit-user-category-parent="editUserNameCategoryParent"
            :in-edit-user-name="editUserNameField"
            @close-edit-user-name-dialog="(dialogName) => { closeDialog(dialogName) }"
            @user-edited="(categoryKey, newUserKey, newGroupKey, login, password, editProfile) => { processEditUser(categoryKey, newUserKey, newGroupKey, login, password, editProfile) }"></dialog-edit-user>

        <dialog-add-edit-device-name v-if="editUserNameParent && editUserNameCategoryParent && addEditDeviceDialog"
                                     :params="addEditDeviceDialogParams"></dialog-add-edit-device-name>

        <dialog-add-edit-device-mobile
            v-if="editUserNameParent && editUserNameCategoryParent && addEditDeviceMobileDialog"
            :params="addEditDeviceMobileDialogParams" @mobile-device-updated="handleMobileDeviceUpdate"
            @mobile-device-added="handleMobileDeviceAdd"
            @open-manage-apps-dialog="(params) => { openManageAppsDialog(params) }"></dialog-add-edit-device-mobile>

        <dialog-add-edit-sub-users
            v-if="addEditSubUsersCategoryParent && addEditSubUsersUserParent && addEditSubUsersDialog"
            :params="addEditSubUsersDialogParams"></dialog-add-edit-sub-users>

        <dialog-add-user-under-category v-if="addUserUnderCategoryDialog"
                                        :params="addUserUnderCategoryParams"></dialog-add-user-under-category>
        <dialog-add-category v-if="addCategoryDialog" :params="addCategoryParams"></dialog-add-category>

        <dialog-users-and-category-manage-apps v-if="manageAppsDialog"
                                               :params="manageAppsDialogParams"></dialog-users-and-category-manage-apps>

        <dialog-users-and-category-add-edit-credentials v-if="addEditCredentialsDialog"
                                                        :params="addEditCredentialsDialogParams"
                                                        @credentials-updated="handleCredentialsUpdate"></dialog-users-and-category-add-edit-credentials>

        <snackbar ref="snackbar"></snackbar>

    </div>
</template>


<script>
/**
 Some old coding here would mention the group of the user as a category. This is because that is how we used to call it earlier, however, later we may rename all to users' categories as users' groups.
 */
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import MixinConfigUsers from '@/mixins/database/MixinConfigUsers'
import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import {debounce, findIndex, forEach, isArray, isEqual} from 'lodash'
import DialogUsersAndCategoryEditUserGroup
    from '@/components/dialogs/users_and_categories_tab/DialogUsersAndCategoryEditUserGroup'
import DialogUsersAndCategoryEditUser
    from '@/components/dialogs/users_and_categories_tab/DialogUsersAndCategoryEditUser'
import Snackbar from '@/components/Snackbar'
import MixinSwalConfirmation from '@/mixins/swal/MixinSwalConfirmation'
import DialogUsersAndCategoryAddEditDevice
    from '@/components/dialogs/users_and_categories_tab/DialogUsersAndCategoryAddEditDevice'
import DialogUsersAndCategoryAddUserUnderCategory
    from '@/components/dialogs/users_and_categories_tab/DialogUsersAndCategoryAddUserUnderCategory'
import DialogUsersAndCategoryAddUserGroup
    from '@/components/dialogs/users_and_categories_tab/DialogUsersAndCategoryAddUserGroup'
import DialogUsersAndCategoryAddEditSubUsers
    from './dialogs/users_and_categories_tab/DialogUsersAndCategoryAddEditSubUsers'
import {useRulesStore} from '@/stores/RulesStore'
import {useUsersStore} from '@/stores/UsersStore'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import {mapWritableState} from 'pinia'
import draggable from 'vuedraggable'
import {
    VExpansionPanels
} from 'vuetify/lib'
import MixinDraggable from '@/mixins/MixinDraggable'
import MixinGenericComponent from '@/mixins/generic/MixinGenericComponent'
import {Affix} from 'vue-affix'
import MixinTranslation from '@/mixins/translation/MixinTranslation'
import DialogUsersAndCategoryAddEditDeviceMobile
    from "@/components/dialogs/users_and_categories_tab/DialogUsersAndCategoryAddEditDeviceMobile.vue";
import {usePhonesStore} from "@/stores/PhonesStore";
import DialogUsersAndCategoryManageApps
    from "@/components/dialogs/users_and_categories_tab/DialogUsersAndCategoryManageApps.vue";
import MixinConfiguration from "@/mixins/mobile_apps/MixinConfiguration";
import {usePhoneTypesStore} from "@/stores/PhoneTypesStore";
import MixinDark from "@/mixins/database/MixinDark";
import constants from '@/assets/js/constants'
import DialogUsersAndCategoryAddEditCredentials
    from "@/components/dialogs/users_and_categories_tab/DialogUsersAndCategoryAddEditCredentials.vue";
import MixinGenericLocalStorage from "@/mixins/MixinGenericLocalStorage";
import {useConnectionsStore} from "@/stores/ConnectionsStore";
import axios from "axios";


Vue.use(VueSweetalert2)
// https://github.com/SortableJS/Vue.Draggable/issues/696
Vue.component('VExpansionPanels', VExpansionPanels)
Vue.use(Affix)

export default {
    name: 'UsersAndCategoriesTab',
    components: {
        DialogUsersAndCategoryAddEditCredentials,
        DialogUsersAndCategoryManageApps,
        dialogAddEditSubUsers: DialogUsersAndCategoryAddEditSubUsers,
        dialogEditGroupName: DialogUsersAndCategoryEditUserGroup,
        dialogEditUser: DialogUsersAndCategoryEditUser,
        dialogAddEditDeviceName: DialogUsersAndCategoryAddEditDevice,
        dialogAddUserUnderCategory: DialogUsersAndCategoryAddUserUnderCategory,
        dialogAddCategory: DialogUsersAndCategoryAddUserGroup,
        dialogAddEditDeviceMobile: DialogUsersAndCategoryAddEditDeviceMobile,
        Snackbar,
        draggable,
        Affix
    },
    mixins: [MixinConfigUsers, MixinIcon, MixinDialog, MixinSwalConfirmation, MixinStringManipulation, MixinDraggable, MixinGenericComponent, MixinTranslation, MixinConfiguration, MixinDark, MixinGenericLocalStorage],
    async mounted() {

        let self = this;

        try {

            if (self.genericLocalStorageHasItem('users.selectedInternetOptionIndex')) {

                let selectedInternetOptionIndex = await self.genericLocalStorageGetItem('users.selectedInternetOptionIndex')

                // I noticed an empty array was set, so we are being careful here.
                if (typeof selectedInternetOptionIndex === 'number') {
                    self.selectedInternetOptionIndex = selectedInternetOptionIndex
                }

            }

        } catch (e) {
            console.error(e)
        }

    },
    data() {
        return {

            userGroupTabFilter: [],

            addCategoryDialog: false,
            addCategoryParams: [],

            addUserUnderCategoryParams: {},
            addUserUnderCategoryDialog: false,

            // Used by Add/Edit Sub users
            addEditSubUsersDialog: false,
            addEditSubUsersCategoryParent: '',
            addEditSubUsersUserParent: '',
            addEditSubUsersMode: '',
            addEditSubUsersSubUserName: '',
            addEditSubUsersPassword: '',
            addEditSubUsersDialogParams: {},

            // Used by Add/Edit device
            addEditDeviceDialogParams: {},
            addEditDeviceMobileDialogParams: {},
            addEditDeviceMode: 'add',
            addEditDeviceDialog: false,
            addEditDeviceMobileDialog: false,
            editDeviceNameField: '',
            editUserNameParent: '',

            // Edit User
            editUserNameDialog: false,
            // Utilised not only for edit users but also for edit devices: mobile and computers
            editUserNameCategoryParent: '',
            editUserNameField: '',
            editUserProfileField: '',
            editLoginField: '',
            editPasswordField: '',

            editCategoryNameField: '',
            editInternetOptionField: '',
            editProfileField: '',
            editCategoryNameDialog: false,

            categoryPanel: '',
            userPanel: [],
            subUserPanel: [],
            userAutoCompleteFilterValue2: '',
            editUserDialog: false,
            selectedChildUser: '',
            userName: '',

            manageAppsDialog: false,
            manageAppsDialogParams: {},
            constants: constants,
            categoryIndexExpansionPanel: {},
            /**
             * userExpansionPanelIndex should be between a type number the index or null, nothing else
             */
            userExpansionPanelIndex: null,
            selectedInternetOptionIndex: 0, // null before
            /**
             * This is helpful for the edit devices
             *
             * @type {string}
             * @default null
             */
            selectedCategory: null,
            user: {}, /* @todo: rename this to currentSelectedUser */

            // Used by Add/Edit credentials
            addEditCredentialsDialogParams: {},
            addEditCredentialsMode: 'add',
            addEditCredentialsDialog: false,
            editCredentialsLoginField: '',
            editCredentialsPasswordField: '',
            userDeviceKindOptions: [
                {
                    'text': 'Personal',
                    'value': 'personal'
                },
                {
                    'text': 'Shared',
                    'value': 'shared'
                }
            ],
            selectedCategoryIndex: -1,
            selectedUserIndex: -1,
            filterText: '',

            selectedUserId: null,
            expansionPanelIndexMap: {}, // Maps category-user keys to their filtered indices
            allInternetOptions: constants.internetOptions,

            isEditSpecialPermissions: false,

            /**
             * Possible values: 'login', 'devices'
             */
            userCredentialsView: 'login',

            addPermanentPermissionLoading: false,


        }
    },
    watch: {

        userGroupTabFilter: {
            handler: function (val) {
                let self = this
                val.includes(0) ? (this.$nextTick(() => self.$refs?.userSearch?.focus())) : ''
            },
            deep: true
        },
        userAutoCompleteFilterValue2: {

            handler: function (val) {

                let self = this
                let matchedUserKey = false
                let matchedSubUserKey = false
                let subUserIndex = 0
                let matchedSubUserIndex = 0
                self.userPanel = []

                // Don't put this in checkCategoryRow as it observes each row carefully, and it resets to 0 even when we want to collapse. i.e. on the click of the panel.
                if (val) {

                    /**
                     * This is more than a boolean. When ospite is searched, the user panel will not open even if it's a complete match. Why? Because, the user key for it is not ospite but Ospite. Hence, this variable carries that information and it's further used as a key for UserPanel. This helps the user panel open even when the search term is not a case-sensitive perfect match.
                     * @type {boolean|string}
                     */
                    self.users?.forEach((category) => {
                        category?.value.forEach((user) => {

                            if (user?.key.toLowerCase() === val.toLowerCase()) {
                                matchedUserKey = user.key
                            }

                            if (!matchedSubUserKey) {
                                subUserIndex = 0
                                user.value.subusers?.forEach((subUser) => {
                                    if (subUser?.key.toLowerCase() === val.toLowerCase()) {
                                        matchedUserKey = user.key
                                        matchedSubUserKey = subUser.key
                                        matchedSubUserIndex = subUserIndex
                                    }
                                    subUserIndex++
                                })
                            }
                        })
                    })

                    if (matchedUserKey && !matchedSubUserKey) {
                        self.$nextTick(() => {
                            self.categoryPanel = 0
                            self.$nextTick(() => {
                                self.userPanel = {
                                    [matchedUserKey]: 0
                                }
                            })
                        })
                    } else if (matchedSubUserKey) {

                        self.$nextTick(() => {

                            self.categoryPanel = 0
                            self.$nextTick(() => {

                                self.userPanel = {
                                    [matchedUserKey]: 0
                                }

                                self.$nextTick(() => {
                                    self.subUserPanel = matchedSubUserIndex

                                    self.$nextTick(() => {
                                        self.$refs['subUser-' + matchedSubUserKey][0].$el.scrollIntoView()
                                    })

                                })

                            })
                        })

                    }
                } else {
                    // Otherwise, if let's say the second category (index:1) was opened for search, the categoryPanel will be set to 0. When the search is cleared 0 would point to something else. Better to reset it.
                    self.closeCategoryPanel()
                    self.userPanel = []
                }

            },
            deep: true
        },

        addEditDeviceDialogParams: {
            handler: function (val) {

            },
            deep: true,
        },
        addEditDeviceMobileDialogParams: {
            handler: function (val) {

            },
            deep: true,
        },

        addEditSubUsersDialogParams: {
            handler: function (val) {

            },
            deep: true,
        },
        categoryIndexExpansionPanel: {
            deep: true,
            handler: function (val) {

                let self = this;

                let allCatsAndUsers = this.filterUsersByInternetOption(this.selectedInternetOption)
                allCatsAndUsers = JSON.parse(JSON.stringify(allCatsAndUsers))

                if (allCatsAndUsers && allCatsAndUsers[this.categoryIndexExpansionPanel]) {
                    allCatsAndUsers[this.categoryIndexExpansionPanel]['value'] = allCatsAndUsers[this.categoryIndexExpansionPanel]['value'].filter((a) => {
                        return !self.userPrivateAttributes.includes(a.key)
                    })

                    self.selectedCategory = allCatsAndUsers[this.categoryIndexExpansionPanel]['key'];
                }


            }
        },
        userExpansionPanelIndex: {
            deep: true,
            handler: function (val, oldVal) {

                let self = this;

                // Prevents user from deselecting the selection.
                if ((val === '' || val === undefined) && oldVal > -1) {
                    self.userExpansionPanelIndex = oldVal
                    return false;
                }

                // Keep selectedUserId in sync
                const category = this.filterUsersByInternetOption(this.selectedInternetOption)[this.categoryIndexExpansionPanel];
                if (category && typeof val === 'number') {
                    const filteredUsers = this.filteredUsers(category);
                    if (filteredUsers[val]) {
                        this.selectedUserId = filteredUsers[val].key;
                    }
                }

                self.populateRight();

            }
        },

        users: {
            deep: true,
            handler: function (val, oldVal) {

            }
        },

        filterText: {
            handler: function (val) {
                let self = this;

                self.refreshAllInternetOptions();

                if (val) {
                    // Clear selection if it's not visible in current filtered results
                    const category = this.filterUsersByInternetOption(this.selectedInternetOption)[this.categoryIndexExpansionPanel];
                    if (category) {
                        const filteredUsers = this.filteredUsers(category);

                        // Check if current selection is in filtered results
                        const currentSelectionVisible = filteredUsers.some(user => user.key === this.selectedUserId);

                        if (!currentSelectionVisible) {
                            // Clear selection
                            this.userExpansionPanelIndex = null;
                            this.selectedUserId = null;

                            // Auto-select first exact match
                            const exactMatch = filteredUsers.find(user =>
                                user.key.toLowerCase() === val.toLowerCase()
                            );

                            if (exactMatch) {
                                const index = filteredUsers.findIndex(u => u.key === exactMatch.key);
                                this.handleUserExpansion(category, exactMatch, index);
                            }
                        }
                    }
                } else {
                    // Clear selection when search is cleared
                    this.userExpansionPanelIndex = null;
                    this.selectedUserId = null;
                }

                self.populateRight();
            }

        },

        selectedUserId: {
            handler: function (val, oldVal) {

                let self = this;

                self.userCredentialsView = 'login';

                if (!val && oldVal) {
                    // Prevent deselection
                    this.selectedUserId = oldVal;
                    return;
                }

                // Keep expansion panel index in sync
                if (val) {

                    const category = this.filterUsersByInternetOption(this.selectedInternetOption)[this.categoryIndexExpansionPanel];
                    if (category) {
                        const filteredUsers = this.filteredUsers(category);
                        const index = filteredUsers.findIndex(u => u.key === val);
                        if (index !== -1) {
                            this.userExpansionPanelIndex = index;

                            if (!filteredUsers[index]['value'].hasOwnProperty('login') || !filteredUsers[index]['value']['login']) {
                                self.userCredentialsView = 'devices';
                            }

                        }
                    }

                }
            }
        },
        selectedInternetOptionIndex: {
            handler: function (newVal, oldVal) {

                if (typeof newVal === 'number') {
                    let self = this;
                    self.genericLocalStorageSetItem('users.selectedInternetOptionIndex', self.selectedInternetOptionIndex)
                }

            }
        }
    },
    computed: {
        ...mapWritableState(usePhonesStore, {
            configurations: 'configurations',
            currentSelectedConfiguration: 'currentSelectedConfiguration',
            currentSelectedConfigurationIndex: 'currentSelectedConfigurationIndex',
            chosenModel: 'chosenModel',
        }),
        ...mapWritableState(useUsersStore, {
            users: 'users',
        }),
        ...mapWritableState(useRulesStore, {
            rules: 'rules',
        }),
        ...mapWritableState(usePhoneTypesStore, {
            phoneTypes: 'phoneTypes',
            appsCommon: 'appsCommon',
            phoneTypeIndex: 'phoneTypeIndex',
        }),
        componentDataForUserGroup() {

            let self = this

            return {
                attrs: {
                    // 'inset': 'inset',
                },
                on: {
                    'change': (val) => {
                        self.categoryPanel = val
                    },
                    'input': (val) => {
                        self.categoryPanel = val
                    }
                },
                props: {
                    'value': this.categoryPanel,
                }
            }

        },
        haveUsers() {

            let self = this

            let haveRecords = true

            if (self.userAutoCompleteFilterValue2?.length > 0) {

                haveRecords = false

                self.users?.forEach((category) => {
                    category?.value.forEach((user) => {
                        if (user?.key.toLowerCase().includes(self.userAutoCompleteFilterValue2.toLowerCase())) {
                            haveRecords = true
                        }
                    })
                })

                if (!haveRecords) {

                    self.users?.forEach((category) => {
                        category.value.forEach((user) => {
                            user.value.subusers?.forEach((subuser) => {
                                if (subuser.key.toLowerCase().includes(self.userAutoCompleteFilterValue2.toLowerCase())) {
                                    haveRecords = true
                                }
                            })
                        })
                    })

                }

            } else if (self.users.length === 0) {
                haveRecords = false
            }

            return haveRecords

        },
        /**
         * These are applicable for category level
         * @returns {string[]}
         */
        userPrivateAttributes() {
            return ['@_internet', '@_categories_profile']
        },
        /**
         * applicable on user level
         * @returns {string[]}
         */
        userLevelPrivateAttributes() {
            return ['categories_profile']
        },
        selectedInternetOption() {
            return this.constants.internetOptions[this.selectedInternetOptionIndex]?.value;
        },
        selectedUserAccountType: {
            get() {
                return this.users[this.selectedCategoryIndex]?.value?.[this.selectedUserIndex]?.value?.account_type || '';
            },
            set(newValue) {
                if (this.users[this.selectedCategoryIndex]?.value?.[this.selectedUserIndex]?.value) {
                    Vue.set(this.users[this.selectedCategoryIndex].value[this.selectedUserIndex].value, 'account_type', newValue);
                }
            }
        },
        selectedUserSuffix: {
            get() {
                return this.users[this.selectedCategoryIndex]?.value?.[this.selectedUserIndex]?.value?.suffix || '';
            },
            set(newValue) {
                if (this.users[this.selectedCategoryIndex]?.value?.[this.selectedUserIndex]?.value) {
                    Vue.set(this.users[this.selectedCategoryIndex].value[this.selectedUserIndex].value, 'suffix', newValue);
                }
            }
        },

        ...mapWritableState(useConnectionsStore, {
            connectionsIsEnabled: 'isEnabled',
        }),
    },
    methods: {

        openUserGroupPanel(userGroup) {

            let self = this;
            let userGroupIndex = self.users.findIndex(user => user.key === userGroup);
            self.categoryPanel = userGroupIndex
            return userGroupIndex;

        },

        /**
         * @param userGroup
         * @param user
         */
        openUserGroupAndUserPanel(userGroup, user) {

            let self = this;
            let userGroupIndex = self.openUserGroupPanel(userGroup);

            self.userPanel = {[user]: 0};
        },

        openManageAppsDialog(params) {

            params.manageAppsDialog = true;

            let self = this;
            self.configurationSetCurrentConfiguration(params.group, params.user, params.device);
            self.manageAppsDialog = true;
            self.manageAppsDialogParams = params;


        },

        /**
         * User is a must because devices are not unique globally. They are unique per user.
         * @param user
         * @param deviceName
         */
        getDeviceByName(user, deviceName) {

            let device = false;

            this.users?.forEach((category) => {
                category.value.forEach((u) => {
                    if (u.key === user) {
                        u.value.devices.forEach((d) => {
                            if (d.key === device && !device) {
                                device = d;
                            }
                        })
                    }
                })
            })

            return device;

        },

        /**
         *
         * @param devices
         * @param filterBy
         * @returns {*}
         */
        getDevicesFromInput(devices, filterBy = 'computer') {

            let self = this;

            let arr = devices?.filter((d) => {

                if (filterBy === 'computer') {
                    return !d.value.phone
                } else if (filterBy === 'mobile') {
                    return d.value.phone
                }

            });

            if (arr?.length > 0) {
                return arr
            }
            return [];

        },

        getIconForTheDevice(device) {

            let self = this
            let icon = self.icons.mdiLaptop

            if (device.value.hasOwnProperty('phone')) {
                icon = self.icons.mdiCellphone
            } else if (device.key.includes('raspberry')) {
                device.key.includes('raspberry') ? icon = self.icons.mdiRaspberryPi : ''
            } else if (device.key.includes('tablet')) {
                device.key.includes('raspberry') ? icon = self.icons.mdiTablet : ''
            }

            return icon

        },
        equipmentTitle(device) {

            let self = this
            // let status = device.value.active ? 'Active' : 'Inactive'

            return self.$gettextInterpolate(self.$gettext('Mac: %{mac}'), {mac: device?.value?.mac ? device?.value?.mac : ''})
        },
        iconHoverText(user) {

            let equipmentCount = 0
            let self = this

            if (user && user.hasOwnProperty('value') && user.value && user.value.hasOwnProperty('devices') && user.value.devices) {
                equipmentCount = user.value?.devices.length
            }

            return this.$gettextInterpolate(self.$gettext('%{user} has %{rulesApplicableCount} rules applicable, has %{equipmentCount} equipments, and %{subUserCount} sub users.'), {
                'user': user.key,
                'rulesApplicableCount': this.allTheRulesThatAreApplicableToUser(user.key)['length'],
                'equipmentCount': equipmentCount,
                'subUserCount': (user && user.value.hasOwnProperty('subusers') && user.value.subusers && Object.keys(user.value.subusers).length) ? Object.keys(user.value.subusers).length : 0
            })

        },
        currentUserCountForUserGroup(category) {

            let self = this
            let count = 0

            category.value.forEach((user) => {
                if (self.userAutoCompleteFilterValue2 && self.userAutoCompleteFilterValue2.length > 0) {
                    if (user.key.toLowerCase().includes(self.userAutoCompleteFilterValue2.toLowerCase())) {
                        count++
                    }
                } else if (typeof user.value === 'object') { // To avoid @_internet being counted as 1
                    count++
                }
            })

            // This value is used by v-badge content. If it's 0, it's accepted as false, and the badge content does not show. Hence, the following.
            return count === 0 ? '0' : count

        },

        doesRuleHaveAValidTimeCondition(rule) {
            return (rule?.value?.hasOwnProperty('time_condition') && isArray(rule?.value?.time_condition) && rule?.value?.time_condition?.length > 0)
        },
        /**
         *
         * This function must return Array as the caller code is programmed to expect an array.
         *
         * @returns {Array}
         * @param userKey
         */
        allTheRulesThatAreApplicableToUser(userKey) {
            const rules = this.rules.filter(rule => (rule?.value?.any_user === 1 || rule?.value?.users?.includes(userKey)))
            return (isArray(rules) && rules.length > 0) ? rules : []
        },
        isAtInternetValueForCategory(category) {

            let atInternetIndex = findIndex(category.value, {key: '@_internet'})

            if (atInternetIndex !== -1) {
                return category.value[atInternetIndex].value
            }

            return false

        },

        componentDataForUser(userKey) {

            let self = this

            return {
                attrs: {
                    'inset': 'inset',
                },
                on: {
                    'change': (val) => {
                        self.userPanel[userKey] = val
                    },
                    'input': (val) => {
                        self.userPanel[userKey] = val
                    }
                },
                props: {
                    'value': self.userPanel[userKey],
                }
            }
        },

        categoryPanelClicked(categoryIndex) {

            /*let self = this

             if ( !self.userAutoCompleteFilterValue2) {
                if (self.categoryPanel === categoryIndex) {
                    self.closeCategoryPanel()
                } else {
                    setTimeout(function () {
                        self.categoryPanel = categoryIndex
                    }, 1)
                }
            } else {

                if (self.categoryPanel === 0) {
                    self.closeCategoryPanel()
                } else {
                    // This is handled at a difference place.
                }
            } */

        },
        /*
                toggleUserPanel(userKey) {

                    let self = this

                     if (self.userPanel.hasOwnProperty(userKey) && self.userPanel[userKey] === 0) {
                        self.userPanel = undefined
                    } else {
                       setTimeout(function (){
                           self.userPanel = {
                               [userKey]: 0
                           }
                       }, 10)
                    }

        },
*/


        setFieldsForAddEditSubUsersDialog(parentCategory, parentUser, mode, subUserName, password) {

            let self = this

            self.addEditSubUsersCategoryParent = parentCategory
            self.addEditSubUsersUserParent = parentUser
            self.addEditSubUsersMode = mode
            self.addEditSubUsersSubUserName = subUserName
            self.addEditSubUsersPassword = password

        },

        /**
         *
         * This is currently common between mobile and computer devices.
         *
         * @param parentCategory
         * @param parentUser
         * @param deviceName
         * @param mode
         */
        setFieldsForAddEditDeviceDialog(parentCategory, parentUser, deviceName, mode) {

            let self = this

            self.editUserNameCategoryParent = parentCategory
            self.editUserNameParent = parentUser
            self.editDeviceNameField = deviceName
            self.addEditDeviceMode = mode

        },

        setFieldsForAddEditCredentialsDialog(login, password, mode) {

            let self = this

            self.editCredentialsLoginField = login
            self.editCredentialsPasswordField = password
            self.addEditCredentialsMode = mode

            return true;

        },


        /**
         * When dependencies are updated, this should be updated but it isn't.
         * Doing it manually for now.
         */
        refreshParamsForAddEditSubUsersDialog() {

            let self = this

            self.addEditSubUsersDialogParams = {
                addEditSubUsersDialog: self.addEditSubUsersDialog,
                userCategoryParent: self.addEditSubUsersCategoryParent,
                userParent: self.addEditSubUsersUserParent,
                mode: self.addEditSubUsersMode,
                subUserName: self.addEditSubUsersSubUserName,
                password: self.addEditSubUsersPassword,
            }

        },
        /**
         * When dependencies are updated, this should be updated but it isn't.
         * Doing it manually for now.
         */
        refreshParamsForAddEditDeviceMobileDialog(active) {

            let self = this

            self.addEditDeviceMobileDialogParams = {
                editDeviceMobileDialog: self.addEditDeviceMobileDialog,
                userCategoryParent: self.editUserNameCategoryParent,
                userParent: self.editUserNameParent,
                deviceName: self.editDeviceNameField,
                mode: self.addEditDeviceMode,
                active
            }

        },
        refreshParamsForAddEditCredentialsDialog() {

            let self = this

            self.addEditCredentialsDialogParams = {
                editCredentialsDialog: self.addEditCredentialsDialog,
                login: self.editCredentialsLoginField,
                password: self.editCredentialsPasswordField,
                mode: self.addEditCredentialsMode,
                userCategoryParent: self.selectedCategory,
                userParent: self.user.key,
            }

        },

        /**
         * When dependencies are updated, this should be updated but it isn't.
         * Doing it manually for now.
         */
        refreshParamsForAddEditDeviceDialog(mac, active) {

            let self = this

            self.addEditDeviceDialogParams = {
                editDeviceDialog: self.addEditDeviceDialog,
                userCategoryParent: self.editUserNameCategoryParent,
                userParent: self.editUserNameParent,
                deviceName: self.editDeviceNameField,
                mode: self.addEditDeviceMode,
                mac,
                active
            }
        },

        navigateToRule(ruleKey, ruleValue) {

            let self = this
            // self.$emit('filter-rules', ruleKey)
            let homeComponent = self.genericComponentGetComponent('Home')
            homeComponent.currentTab = constants.rulesTabIndex

            function removePreviousRuleSelection() {
                homeComponent.$refs.internetFilterTabRef.rulesListItem = ''
            }

            const selectRule = () => {

                homeComponent.$refs.internetFilterTabRef.selectRule(ruleKey, ruleValue)

                self.$nextTick(() => {
                    setTimeout(() => {
                        homeComponent.$refs.internetFilterTabRef.$refs['rule-' + ruleKey][0].$el.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                            inline: 'nearest'
                        })
                    }, 100)
                })

            }

            // This is important because, when the first time the code runs and lets say internet filter tab was never visited. Then the internet filter tab ref will be undefined. So we are switching the tab, giving it some time, and we are calling the function.
            if (typeof homeComponent.$refs.internetFilterTabRef === 'undefined') {

                self.$nextTick(() => {
                    setTimeout(() => {
                        removePreviousRuleSelection()
                        selectRule()
                    }, 50)
                })

            } else {
                removePreviousRuleSelection()
                // If the internet filter tab is already rendered, we don't need to wait.
                selectRule()
            }

        },

        closeCategoryPanel() {
            let self = this
            setTimeout(function () {
                self.categoryPanel = undefined
            }, 10)
        },

        closeUserPanel() {
            let self = this
            self.userPanel = ''
        },

        processEditUserGroup(newCategoryName, newInternetOption, editProfile) {

            let self = this
            self.$refs.snackbar.showSnackbar(self.$gettext('User group fields were updated successfully'))

            self.updateUserGroupCategory(self.editCategoryNameField, newCategoryName, newInternetOption, editProfile)

            self.configurations.forEach((configuration) => {
                if (configuration.value.hasOwnProperty('user_group')) {
                    if (configuration.value.user_group === self.editCategoryNameField) {
                        configuration.value.user_group = newCategoryName
                    }
                }
            })

        },
        async processEditUser(categoryKey, newUser, newGroupKey, login = '', password = '', editProfile) {

            let self = this

            const currentUserExpansionIndex = self.userExpansionPanelIndex;

            self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('User information updated successfully for %{name}'), {name: newUser}))

            let categoryIndex = findIndex(self.users, {key: categoryKey})
            let userIndex = findIndex(self.users[categoryIndex]['value'], {key: self.editUserNameField})

            if (userIndex !== -1) {
                self.users[categoryIndex]['value'][userIndex]['value']['login'] = login
                self.users[categoryIndex]['value'][userIndex]['value']['password'] = password
                Vue.set(self.users[categoryIndex]['value'][userIndex]['value'], 'categories_profile', editProfile)
            }

            // self.configUserUpdateUserLevelNode(categoryKey, self.editUserNameField, newUser)
            self.configUserReplaceTheKeyWithOnTheUserLevel(categoryKey, newGroupKey, self.editUserNameField, newUser)

            if (self.editUserNameField === self.userAutoCompleteFilterValue2) {
                self.userAutoCompleteFilterValue2 = newUser
            }

            forEach(self.rules, function (rule) {
                if (rule.value.hasOwnProperty('users') && isArray(rule.value.users)) {

                    forEach(rule.value.users, function (user) {
                        if (user === self.editUserNameField) {
                            rule.value.users[rule.value.users.indexOf(user)] = newUser
                        }
                    })

                }
            })

            if (newGroupKey) {
                self.changeCategoryOfUser(categoryKey, newGroupKey, newUser)
            }

            self.configurations.forEach((configuration) => {
                if (configuration.value.hasOwnProperty('user_group')) {
                    if (configuration.value.user_group === categoryKey && configuration.value.user === self.editUserNameField) {
                        configuration.value.user_group = newGroupKey
                        configuration.value.user = newUser
                    }
                }
            })


            await self.$nextTick();


            // If category changed, update category panel first
            if (newGroupKey && newGroupKey !== categoryKey) {
                // Find the new category index
                const newCategoryIndex = findIndex(self.filterUsersByInternetOption(self.selectedInternetOption),
                    {key: newGroupKey});

                if (newCategoryIndex !== -1) {
                    self.categoryIndexExpansionPanel = newCategoryIndex;

                    // Wait for category panel to update
                    await self.$nextTick();

                    // Find the user's new index in filtered users
                    const category = self.filterUsersByInternetOption(self.selectedInternetOption)[newCategoryIndex];
                    const filteredUsers = self.filteredUsers(category);
                    const newUserIndex = findIndex(filteredUsers, {key: newUser});

                    if (newUserIndex !== -1) {
                        self.userExpansionPanelIndex = newUserIndex;
                    }
                }
            } else {
                self.userExpansionPanelIndex = currentUserExpansionIndex;
            }

            await self.$nextTick();
            await self.$nextTick();

            self.populateRight();


        },

        checkEachCategory(category, categoryIndex) {

            let self = this
            let categoryVisibility = true

            if (self.userAutoCompleteFilterValue2?.length > 0) {

                categoryVisibility = false

                category.value.forEach((user) => {
                    user.key.toLowerCase().includes(self.userAutoCompleteFilterValue2.toLowerCase()) ? categoryVisibility = true : ''
                })

                if (!categoryVisibility) {
                    category.value.forEach((user) => {
                        user.value.subusers?.forEach((subuser) => {
                            subuser.key.toLowerCase().includes(self.userAutoCompleteFilterValue2.toLowerCase()) ? categoryVisibility = true : ''
                        })
                    })
                }

            }

            return categoryVisibility

        },
        checkEachUser(categoryKey, userKey, categoryIndex) {

            let self = this

            let userVisibility = true
            let atLeastOneMatch = false

            if (['@_internet', '@_categories_profile'].includes(userKey)) {
                userVisibility = false
                return userVisibility
            }

            if (self.userAutoCompleteFilterValue2?.length > 0) {
                userVisibility = false

                if (userKey.toLowerCase().includes(self.userAutoCompleteFilterValue2.toLowerCase())) {
                    userVisibility = true
                }

                /*if (userKey !== self.userAutoCompleteFilterValue2) {
                    userVisibility = false
                } else {
                    atLeastOneMatch = true
                }*/

                if (!userVisibility) {

                    self.users?.forEach((category) => {
                        if (category.key === categoryKey) {
                            category.value.forEach((user) => {
                                if (user.key === userKey) {
                                    user.value.subusers?.forEach((subuser) => {
                                        if (subuser.key.toLowerCase().includes(self.userAutoCompleteFilterValue2.toLowerCase())) {
                                            userVisibility = true
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            }

            return userVisibility

        },

        closeEditUserDialog() {
            this.editUserDialog = false
        },
        selectChildUser(categoryKey, userKey) {
            let self = this
            self.selectedChildUser = categoryKey + '_' + userKey
        },
        openEditUserGroup(category) {

            let self = this

            let atInternetIndex = findIndex(category.value, (user) => user.key === '@_internet')
            let atProfileIndex = findIndex(category.value, (user) => user.key === '@_categories_profile')

            self.editCategoryNameDialog = true
            self.editCategoryNameField = category.key
            if (atInternetIndex !== -1) {
                self.editInternetOptionField = category.value[atInternetIndex].value
            }
            if (atProfileIndex !== -1) {
                self.editProfileField = category.value[atProfileIndex].value
            }
            return false
        },

        /**
         * Opens the dialog window to edit a user, initializing various fields related to the user.
         *
         * @param {string} parentCategory - The name of the category / The parent category associated with the user.
         * @param {string} userName - The name of the user to be edited.
         * @param {Object} userValue - An object containing the user's login and password information.
         * @param {string} [userValue.login] - The login of the user.
         * @param {string} [userValue.password] - The password of the user.
         *
         * @return {boolean} Always returns false.
         */
        openEditUser(parentCategory, userName, userValue) {

            let self = this
            self.editUserNameCategoryParent = parentCategory
            self.editUserNameDialog = true
            self.editUserNameField = userName

            self.editLoginField = userValue.login ? userValue.login : ''
            self.editPasswordField = userValue.password ? userValue.password : ''

            let {userIndex, userCategoryIndex} = self.configUserGetCategoryAndUserIndex(parentCategory, userName)

            let userHasProfile = false;

            /*---------------------------------------------
                If user has a categories profile set we take that
            ----------------------------------------------*/
            let sfUsers = self.users[userCategoryIndex]['value'][userIndex]['value'];
            for (let attr in sfUsers) {
                if (attr === 'categories_profile' && sfUsers[attr].length) {
                    userHasProfile = true;
                    self.editUserProfileField = sfUsers[attr];
                }
            }

            if (!userHasProfile) {
                let atProfileIndex = findIndex(self.users[userCategoryIndex].value, (user) => user.key === '@_categories_profile')
                if (atProfileIndex !== -1) {
                    self.editUserProfileField = self.users[userCategoryIndex].value[atProfileIndex].value
                } else {
                    console.error('Profile category not found for user.');
                }
            }

            return false
        },
        openAddUserUnderCategoryDialog(categoryKey) {

            let self = this

            self.addUserUnderCategoryDialog = true
            self.addUserUnderCategoryParams = {
                categoryKey,
                addUserUnderCategoryDialog: self.addUserUnderCategoryDialog
            }

            return false

        },
        openAddCategoryDialog(internetOptionValue) {

            let self = this
            self.addCategoryDialog = true
            self.addCategoryParams = {
                addCategoryDialog: self.addCategoryDialog,
                internetProp: internetOptionValue
            }

            return false

        },

        openAddEditSubUsersDialog(parentCategory, parentUser, mode, subUserName = null, password = null) {

            let self = this
            self.addEditSubUsersDialog = true
            self.setFieldsForAddEditSubUsersDialog(parentCategory, parentUser, mode, subUserName, password)
            self.refreshParamsForAddEditSubUsersDialog()

            return false

        },

        openAddEditDeviceDialog(parentCategory, parentUser, mode, deviceName = '', mac = '', active = 1) {

            let self = this

            self.addEditDeviceDialog = true
            self.setFieldsForAddEditDeviceDialog(parentCategory, parentUser, deviceName, mode)
            self.refreshParamsForAddEditDeviceDialog(mac, active)

            return false

        },
        openAddEditDeviceMobileDialog(parentCategory, parentUser, mode, deviceName = '', active = 1) {

            let self = this

            self.addEditDeviceMobileDialog = true
            self.setFieldsForAddEditDeviceDialog(parentCategory, parentUser, deviceName, mode)
            self.refreshParamsForAddEditDeviceMobileDialog(active)

            return false

        },
        openAddEditCredentialsDialog(login = '', password = '', mode) {

            let self = this

            self.addEditCredentialsDialog = true // if it's not the first line, it will require two clicks #106
            self.setFieldsForAddEditCredentialsDialog(login, password, mode)
            self.refreshParamsForAddEditCredentialsDialog()

            return false

        },
        deleteCategory(categoryKey) {

            let self = this

            let deleteCategory = function (self) {

                self.configurationBulkDelete(categoryKey)

                let index = findIndex(self.users, val => val.key === categoryKey)

                if (index !== -1) {

                    // If search is in progress, and the (only) available category is deleted, the input field should be reset.
                    if (self.userAutoCompleteFilterValue2 && self.userAutoCompleteFilterValue2.length >= 0) {
                        self.userAutoCompleteFilterValue2 = ''
                        self.closeCategoryPanel()
                    }

                    // Delete all the users and subusers from the rules
                    forEach(self.users[index].value, function (user) {

                        forEach(self.rules, function (rule) {
                            if (rule.value.hasOwnProperty('users') && isArray(rule.value.users)) {
                                if (rule.value.users.indexOf(user.key) !== -1) {
                                    rule.value.users.splice(rule.value.users.indexOf(user.key), 1)
                                }
                            }
                        })

                        user.value.subusers?.forEach((subuser) => {
                            forEach(self.rules, function (rule) {
                                if (rule.value.hasOwnProperty('users') && isArray(rule.value.users)) {
                                    if (rule.value.users.indexOf(subuser.key) !== -1) {
                                        rule.value.users.splice(rule.value.users.indexOf(subuser.key), 1)
                                    }
                                }
                            })
                        })

                    })

                    self.users.splice(index, 1)
                    self.configurations.filter(c => !(c.value.user_group === categoryKey));

                }

                return true

            }

            let swalOptions = {
                successCallback: deleteCategory,
                title: self.$gettext('Delete category'),
                description: self.$gettextInterpolate(self.$gettext('Are you sure, you want to delete the category, %{category}?'), {category: categoryKey}),
                confirmButtonText: self.$gettext('Yes, Delete it!'),
                icon: 'warning',
                successText: self.$gettextInterpolate(self.$gettext('Category %{category} is deleted successfully!'), {category: categoryKey}),
            }

            self.swalConfirmation(swalOptions)

        },
        deleteUser(categoryKey, userKey) {

            let self = this

            let deleteUser = function (self) {

                self.configurationBulkDelete(categoryKey, userKey)

                let userCategoryIndex = findIndex(self.users, val => (val.key === categoryKey))

                if (userCategoryIndex !== -1) {

                    self.configurations = self.configurations.filter(({value}) =>
                        !('user_group' in value && value.user_group === categoryKey && value.user === userKey)
                    );

                    // This is a solution to a bit of an edge case scenario.
                    // If the searched user is deleted, we want to reset the search.
                    if (self.userAutoCompleteFilterValue2 && self.userAutoCompleteFilterValue2.length >= 0 && self.userAutoCompleteFilterValue2 === userKey) {
                        self.userAutoCompleteFilterValue2 = ''
                        self.closeCategoryPanel()
                    }

                    let userIndex = findIndex(self.users[userCategoryIndex].value, val => (val.key === userKey))

                    if (userIndex !== -1) {

                        forEach(self.rules, function (rule) {
                            if (isArray(rule?.value?.users)) {
                                (rule.value.users.indexOf(userKey) !== -1) ? rule.value.users.splice(rule.value.users.indexOf(userKey), 1) : ''
                            }
                        })

                        self.users[userCategoryIndex].value.splice(userIndex, 1)
                        return true

                    }


                    return false

                }

            }

            let swalOptions = {
                successCallback: deleteUser,
                title: this.$gettext('Delete User'),
                description: this.$gettextInterpolate(this.$gettext('Are you sure, you want to delete the user, %{user}?'),
                    {user: userKey}),
                confirmButtonText: this.$gettext('Yes, Delete it!'),
                icon: 'warning',
                successText: this.$gettextInterpolate(this.$gettext('User %{user} is deleted successfully!'), {user: userKey}),
            }

            self.swalConfirmation(swalOptions)

        },
        deleteMobileEquipmentAndConfiguration(categoryKey, userKey, nodeKey, nodeName, entityName) {

            let self = this;

            const deleteMobileFn = () => {
                self.configurationDeleteByDeviceDetails(categoryKey, userKey, nodeKey)
                // The toast message post deletion comes from this method
                self.configUserProcessUserChildNodeDelete(categoryKey, userKey, nodeKey, nodeName, entityName, 1)
            }

            const entityAndItem = {'entity': entityName, 'item': nodeKey}

            let swalOptions = {
                successCallback: deleteMobileFn,
                title: self.$gettextInterpolate(self.$gettext('Delete %{entity}'), {entity: entityName}),
                description: self.$gettextInterpolate(self.$gettext('Are you sure, you want to delete the %{entity}, %{item}?'), entityAndItem),
                confirmButtonText: self.$gettext('Yes, Delete it!'),
                icon: 'warning',
                cancelButtonText: self.$gettext('Cancel'),
            }

            self.swalConfirmation(swalOptions)

        },
        deleteUserNode(categoryKey, userKey, nodeKey, nodeName, entityName) {

            let self = this
            let deleteUserNode = () => self.configUserProcessUserChildNodeDelete(categoryKey, userKey, nodeKey, nodeName, entityName, 1)
            const entityAndItem = {'entity': entityName, 'item': nodeKey}

            let swalOptions = {
                successCallback: deleteUserNode,
                title: self.$gettextInterpolate(self.$gettext('Delete %{entity}'), {entity: entityName}),
                description: self.$gettextInterpolate(self.$gettext('Are you sure, you want to delete the %{entity}, %{item}?'), entityAndItem),
                confirmButtonText: self.$gettext('Yes, Delete it!'),
                icon: 'warning',
                successText: self.$gettextInterpolate(self.$gettext('%{ entity } %{ item } is deleted successfully!'), entityAndItem),
                cancelButtonText: self.$gettext('Cancel'),
            }

            self.swalConfirmation(swalOptions)


        },

        /**
         *
         * Filters users based on the specified internet option. Useful for displaying classifications, one by one.
         *
         * This function dealing with users directly, binds the reactivity wherever used it, hence it is advised so that except for the places of UI (template codes), when used in codes (js part), do stringify and parse, to avoid manipulating the main users object itself.
         *
         * @param {string} internetOption - The internet option to filter users by.
         * @return {Array} An array of users that have the specified internet option.
         *
         */
        filterUsersByInternetOption(internetOption) {

            let self = this

            let cats = (self.users?.filter((category) => {

                return category.value.some((user) => {

                    // Eventhough we have user.key here, but what we are checking is category property, that and user are mixed in one.
                    if (user.key === '@_internet' && user.value === internetOption) {
                        return true
                    }

                })

            }))

            if (self.filterText) {

                cats = cats.filter(c => {
                    return self.filteredUsers(c)['length']
                })

            }

            return cats;

        },

        isUser(user) {
            return user.value.hasOwnProperty('devices') && !user.value.hasOwnProperty('@_internet');
        },

        isFolder(user) {
            return !user.value.hasOwnProperty('devices') && user.value.hasOwnProperty('@_internet');
        },
        underDevelopmentAlert() {
            let self = this;

            self.$refs.snackbar.showSnackbar('This feature will soon be available.', 'info')
        },

        filteredUsers(category) {

            let debug = true;

            if (!category || !category.value) {
                return [];
            }
            /*
                        return category.value.filter(user => {
                            if (this.userPrivateAttributes.includes(user.key)) {
                                return false;
                            }

                            if (this.filterText) {
                                return user.key.toLowerCase().includes(this.filterText.toLowerCase());
                            }

                            return true;
                        });
                        */

            const filtered = category.value
                .filter(user => {
                    if (this.userPrivateAttributes.includes(user.key)) {
                        return false;
                    }

                    if (this.filterText) {
                        return user.key.toLowerCase().includes(this.filterText.toLowerCase());
                    }

                    return true;
                });

            // Updates the index mapping for this category
            filtered.forEach((user, filteredIndex) => {
                const mappingKey = `${category.key}-${user.key}`;
                this.expansionPanelIndexMap[mappingKey] = filteredIndex;
            });

            return filtered;

        },

        populateRight() {

            try {

                let self = this;
                self.user = null;

                let allCatsAndUsers = self.filterUsersByInternetOption(self.selectedInternetOption);
                if (!allCatsAndUsers) {
                    throw new Error('Failed to filter users by internet option');
                }

                if (allCatsAndUsers && allCatsAndUsers[self.categoryIndexExpansionPanel]) {
                    const category = allCatsAndUsers[self.categoryIndexExpansionPanel];
                    const filteredUsers = category.value.filter(a => !self.userPrivateAttributes.includes(a.key));

                    if (self.selectedUserId) {
                        const foundUser = filteredUsers.find(u => u.key.toLowerCase() === self.selectedUserId.toLowerCase());
                        if (foundUser) {
                            self.$set(self, 'user', foundUser);
                        } else {
                            self.$set(self, 'user', filteredUsers[self.userExpansionPanelIndex]);
                        }
                    } else if (typeof self.userExpansionPanelIndex === 'number') {
                        const selectedUser = filteredUsers[self.userExpansionPanelIndex];
                        if (selectedUser) {
                            self.$set(self, 'user', selectedUser);
                            self.selectedUserId = selectedUser.key;
                        }
                    }
                }

                if (self.selectedCategory && self.user?.key) {
                    const indices = self.configUserGetCategoryAndUserIndex(self.selectedCategory, self.user.key);
                    if (!indices?.userCategoryIndex && !indices?.userIndex) {
                        throw new Error('Failed to get user indices');
                    }
                    self.$set(self, 'selectedCategoryIndex', indices.userCategoryIndex);
                    self.$set(self, 'selectedUserIndex', indices.userIndex);
                }

            } catch (error) {

                console.error('Data population error:', error.message);
                if (!this.user || !this.selectedCategory) {
                    this.$refs.snackbar?.showSnackbar('Unable to load user details. Please refresh.', 'error');
                }

            }
        },

        handleUserExpansion(category, user, index) {
            try {
                if (!category?.key || !user?.key) {
                    throw new Error('Invalid selection data');
                }

                const categoryKey = category.key;
                const userKey = user.key;
                const mappingKey = `${categoryKey}-${userKey}`;

                this.expansionPanelIndexMap[mappingKey] = index;
                this.selectedUserId = userKey;
                this.userExpansionPanelIndex = index;

                this.selectedCategory = categoryKey;
                this.$set(this, 'user', user);

                const indices = this.configUserGetCategoryAndUserIndex(categoryKey, userKey);

                if (indices) {
                    this.selectedCategoryIndex = indices.userCategoryIndex;
                    this.selectedUserIndex = indices.userIndex;
                } else {
                    throw new Error('Failed to get user indices');
                }

                this.$nextTick(() => {
                    this.populateRight();
                });

            } catch (error) {
                console.error('User selection error:', error.message);
                this.$refs.snackbar?.showSnackbar('Failed to load user data. Please try again.', 'error');
            }
        },

        handleCredentialsUpdate({categoryIndex, userIndex, login, password}) {

            Vue.set(this.users[categoryIndex]['value'][userIndex]['value'], 'login', login);
            Vue.set(this.users[categoryIndex]['value'][userIndex]['value'], 'password', password);

            this.populateRight();
        },

        handleMobileDeviceUpdate({categoryParent, userParent, previousDeviceName, newDeviceName, value}) {
            this.populateRight();
        },

        handleMobileDeviceAdd({categoryParent, userParent, deviceName, value, configurationName}) {
            this.populateRight();
        },
        findCategoryIndex(categoryKey) {
            const allCatsAndUsers = this.filterUsersByInternetOption(this.selectedInternetOption);
            return allCatsAndUsers.findIndex(cat => cat.key === categoryKey);
        },
        refreshAllInternetOptions() {

            let self = this;

            if (!self.filterText) {
                self.allInternetOptions = constants.internetOptions;
            } else {
                self.allInternetOptions = constants.internetOptions.filter(io => {
                    return self.filterUsersByInternetOption(io.value)['length']
                })
            }

        },

        /**
         * This is a box specific feature, and not applicable to SFTP
         * This goes to server and fetches the connected users mac address.
         */
        async loadConnectedUsersMacAddress() {

            let params = {};

            params.operation = 'connected_user_mac_address';
            params.userName = this.user.key;

            return await axios.get('user.php', {
                params
            }).then((response) => {
                return response.data.data.macs;
            }).catch((error) => {
                // TODO: Log error
                console.log(error)
                return false
            })

        },

        async processAddPermanentPermissions() {

            let self = this;

            self.addPermanentPermissionLoading = true;
            const macs = await self.loadConnectedUsersMacAddress();
            self.addPermanentPermissionLoading = false;

            if (macs && Array.isArray(macs)) {

                let filteredMacs = macs.filter(mac => {

                    if (!mac)
                        return false;

                    let returnOfSome = self.user.value.devices.some(device => {
                        return device.value.mac === mac
                    })

                    return !returnOfSome;

                })

                if (filteredMacs.length) {

                    let index = 1;
                    for (let mac of filteredMacs) {
                        self.addDeviceToUser(self.user.key + ' ' + index, mac)
                        index++;
                    }

                    self.$refs.snackbar.showSnackbar(self.$gettext('All connected devices are now added to the list.'), 'success')

                } else {
                    self.$refs.snackbar.showSnackbar(self.$gettext('All connected devices are already added to the list.'), 'info')
                }

            } else {
                self.$refs.snackbar.showSnackbar(self.$gettext('No connected devices found. Maybe the user (' + self.user.key + ') is not connected'), 'info')
            }

        },

        addDeviceToUser(deviceName, mac) {

            let self = this;

            // This manipulation is done on both the sides, client side for while edit manipulation, and the server side performs it for all the devices, it covers the case where the user has not touched the device on the client side but still when saving we do expect the mac address to be in the correct format.
            let value = {
                mac: mac.replaceAll('-', ':').replaceAll(' ', '').toLowerCase(),
                // active: self.active,
            }

            let valueToUpdate = {
                key: deviceName,
                value
            }

            const category = this.filterUsersByInternetOption(this.selectedInternetOption)[this.categoryIndexExpansionPanel];

            // self.configUserAddUserChildNode(self.$props.params.userCategoryParent, self.$props.params.userParent, valueToUpdate, 'devices')
            self.configUserAddUserChildNode(category.key, self.user.key, valueToUpdate, 'devices')

        },


    }
}
</script>
<style type="text/scss">
.bg-light-grey {
    color: red;
}

/** Makes expansions a bit less strong on the ui */
.user-expansions .v-expansion-panel::before {
    -webkit-box-shadow: 0 3px 1px -3px rgb(0 0 0 / 20%), 0 0 2px 0 rgb(0 0 0 / 14%), 0 1px 0 0 rgb(0 0 0 / 12%);
    -moz-box-shadow: 0 3px 1px -3px rgb(0 0 0 / 20%), 0 0 2px 0 rgb(0 0 0 / 14%), 0 1px 0 0 rgb(0 0 0 / 12%);
    -o-box-shadow: 0 3px 1px -3px rgb(0 0 0 / 20%), 0 0 2px 0 rgb(0 0 0 / 14%), 0 1px 0 0 rgb(0 0 0 / 12%);
    box-shadow: 0 3px 1px -3px rgb(0 0 0 / 20%), 0 0 2px 0 rgb(0 0 0 / 14%), 0 1px 0 0 rgb(0 0 0 / 12%);
}

.default-text-colour {
    color: rgba(0, 0, 0, 0.87) !important;
}

.border-bottom-on-hover {
    &:hover {
        //border-bottom: 1px solid rgba(0, 0, 0, 0.12); border-bottom: 1px dotted rgba(0, 0, 0, 0.40);
    }
}

/*------------------------------------------------
    Tree panels
--------------------------------------------------*/
.tree-panels {
    background: transparent !important;
    box-shadow: none !important;
}

.tree-panel-item {
    background: transparent !important;
    border: none !important;
    margin-bottom: 2px !important;
    position: relative !important;
}

/* Remove all borders and shadows */
.tree-panel-item::before,
.tree-panel-item::after {
    display: none !important;
}

:deep(.v-expansion-panel) {
    border-radius: 0 !important;
    box-shadow: none !important;
}

:deep(.v-expansion-panel::before) {
    box-shadow: none !important;
}

:deep(.v-expansion-panel::after) {
    box-shadow: none !important;
}

/* Remove header bottom border */
:deep(.v-expansion-panel-header) {
    padding: 8px 16px !important;
    min-height: 0 !important;
    border-bottom: none !important;
}

:deep(.v-expansion-panel-header::after) {
    display: none !important;
}

:deep(.v-expansion-panel-content__wrap) {
    padding: 0 !important;
}

:deep(.v-expansion-panel-header__icon) {
    display: none !important;
}

/* Maintain the arrow rotation */
.expansion-arrow {
    transition: transform 0.2s ease-in-out;
}

.expansion-arrow.rotated {
    transform: rotate(90deg);
}

/* Hover effect */
.tree-panel-item:hover {
    background-color: rgba(0, 0, 0, 0.04) !important;
}

/* Remove any remnant borders from nested panels */
:deep(.v-expansion-panels) {
    border: none !important;
    box-shadow: none !important;
}

:deep(.v-expansion-panel-content) {
    border: none !important;
}

:deep(.v-expansion-panel-content__wrap) {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    border: none !important;
}

:deep(.v-expansion-panel:not(.v-expansion-panel--active) > .v-expansion-panel-header > .v-expansion-panel-header__icon),
:deep(.v-expansion-panel--active > .v-expansion-panel-header > .v-expansion-panel-header__icon) {
    display: none !important;
}

.tree-panels .v-expansion-panel-header__icon {
    display: none !important;
}

/*------------------------------------------------
    TODO: Clean up the css
--------------------------------------------------*/

.v-application .tree-panels .v-expansion-panel--active > .v-expansion-panel-header {
    font-size: 0.9375rem;
}

.tree-panels .v-expansion-panel-header {
    min-height: 48px !important;
    padding: 4px 12px !important;

    margin: 0 !important;
    transition: none !important;
}

.tree-panels .v-expansion-panel-content__wrap {
    padding: 0 !important;

    margin: 0 !important;
    transition: none !important;
}

.tree-panels .v-expansion-panel-content {
    min-height: 0 !important;
    transition: none !important;
}

.tree-panels .v-expansion-panel {
    min-height: 0 !important;
}

/* Target the outer and inner expansion panels */
.tree-panels .v-expansion-panels--accordion > .v-expansion-panel,
.tree-panels .v-expansion-panel .v-expansion-panel {
    min-height: 0 !important;
}

.tree-panels .v-expansion-panel {
    margin: 0 !important;
    transition: none !important;
}

/* Remove any animation/transition classes */
.tree-panels .v-expansion-panel::before,
.tree-panels .v-expansion-panel::after {
    transition: none !important;
}

.tree-panels .expansion-arrow {
    transition: transform 0.2s ease-in-out !important;
}

.tree-panels .expansion-arrow.rotated {
    transform: rotate(90deg) !important;
}


/* These are the new/modified rules */
.tree-panels .v-expansion-panel::before,
.tree-panels .v-expansion-panel::after {
    display: none !important;
}

.tree-panels .v-expansion-panel {
    margin: 0 !important;
}

.tree-panels .v-expansion-panel-header::after {
    display: none !important;
}

.tree-panels .v-expansion-panel-content {
    border: none !important;
}

.tree-panels .v-expansion-panels {
    border: none !important;
}

/* Previous rules that remain the same */
.tree-panels {
    background: transparent !important;
    box-shadow: none !important;
}

.tree-panel-item {
    background: transparent !important;
    border: none !important;
    margin: 0 !important;
}

.tree-panels .v-expansion-panel-header {
    min-height: 32px !important;
    padding: 4px 12px !important;
    margin: 0 !important;
}

.tree-panels .v-expansion-panel-header__icon {
    display: none !important;
}

.tree-panels .v-expansion-panel-content__wrap {
    padding: 0 !important;
}

.expansion-arrow {
    transition: transform 0.2s ease-in-out;
}

.expansion-arrow.rotated {
    transform: rotate(90deg);
}

/* -------------------------
    Sidebar scroll
    ------------------------*/

/*------------------------------------------------
    For now this is only for desktop
--------------------------------------------------*/

.sidebar-scrollable {
    flex-grow: 1;
    overflow-y: auto;
    height: calc(100vh - 400px);
}

</style>
